


export interface DecodeRegionalPartnership {
  id:   string;
  name: string;
}



export interface WsDecodeLocalAuthority {
  id:                    string;
  name:                  string;
  schools?: WsDecodeSchool[];
}



export interface DecodeSchoolType {
  id:   string;
  name: string;
}



export interface WsDecodeSchool {
  id:                    string;
  regionalPartnershipId: string;
  localAuthorityId:      string;
  name:                  string;
}




const cleanString = (value: any) => {
  if (value) {
    return `${value}`.trim();
  } else {
    return '';
  }
};




function replaceAll(str: string, search: string, replacement: string): string {
  return str.split(search).join(replacement);
}








const hwbDataText = `
GwE||Isle of Anglesey County Council||660||6602130||Ysgol Gynradd Amlwch
GwE||Isle of Anglesey County Council||660||6602131||Ysgol Gynradd Beaumaris
GwE||Isle of Anglesey County Council||660||6602132||Ysgol Gynradd Bodedern
GwE||Isle of Anglesey County Council||660||6602133||Ysgol Gymuned Bodffordd
GwE||Isle of Anglesey County Council||660||6602135||Ysgol Gymuned Bryngwran
GwE||Isle of Anglesey County Council||660||6602136||Ysgol Gynradd Brynsiencyn
GwE||Isle of Anglesey County Council||660||6602138||Ysgol Gynradd Cemaes
GwE||Isle of Anglesey County Council||660||6602140||Ysgol Gynradd Esceifiog
GwE||Isle of Anglesey County Council||660||6602142||Ysgol Gymuned Y Ffridd
GwE||Isle of Anglesey County Council||660||6602145||Ysgol Gymuned Moelfre
GwE||Isle of Anglesey County Council||660||6602146||Ysgol Gynradd Llanbedrgoch
GwE||Isle of Anglesey County Council||660||6602152||Ysgol Gynradd Llanfairpwll
GwE||Isle of Anglesey County Council||660||6602153||Ysgol Gymuned Llanfechell
GwE||Isle of Anglesey County Council||660||6602154||Ysgol Y Graig
GwE||Isle of Anglesey County Council||660||6602155||Ysgol Gynradd Llangoed
GwE||Isle of Anglesey County Council||660||6602156||Ysgol Henblas
GwE||Isle of Anglesey County Council||660||6602157||Ysgol Gymuned Llanerch-y-medd
GwE||Isle of Anglesey County Council||660||6602160||Ysgol Gynradd Pencarnisiog
GwE||Isle of Anglesey County Council||660||6602161||Ysgol Gymuned Pentraeth
GwE||Isle of Anglesey County Council||660||6602162||Ysgol Gynradd Penysarn
GwE||Isle of Anglesey County Council||660||6602163||Ysgol Gynradd Santes Gwenfaen
GwE||Isle of Anglesey County Council||660||6602164||Ysgol Gynradd Rhosneigr
GwE||Isle of Anglesey County Council||660||6602165||Ysgol Gynradd Rhosybol
GwE||Isle of Anglesey County Council||660||6602168||Ysgol Gymuned y Fali
GwE||Isle of Anglesey County Council||660||6602169||Ysgol Llanfawr
GwE||Isle of Anglesey County Council||660||6602170||Ysgol Goronwy Owen
GwE||Isle of Anglesey County Council||660||6602173||Ysgol Gynradd Y Tywyn
GwE||Isle of Anglesey County Council||660||6602174||Ysgol Gynradd Llandegfan
GwE||Isle of Anglesey County Council||660||6602175||Ysgol Gynradd Y Borth
GwE||Isle of Anglesey County Council||660||6602176||Ysgol Gynradd Kingsland
GwE||Isle of Anglesey County Council||660||6602177||Ysgol Gymraeg Morswyn
GwE||Isle of Anglesey County Council||660||6602226||Ysgol Gynradd Corn Hir
GwE||Isle of Anglesey County Council||660||6602227||Ysgol Rhyd y Llan
GwE||Isle of Anglesey County Council||660||6602228||Ysgol Parc Y Bont
GwE||Isle of Anglesey County Council||660||6603036||Ysgol Cybi
GwE||Isle of Anglesey County Council||660||6603037||Ysgol Santes Dwynwen
GwE||Isle of Anglesey County Council||660||6603304||Ysgol Santes Fair
GwE||Isle of Anglesey County Council||660||6604025||Ysgol Syr Thomas Jones
GwE||Isle of Anglesey County Council||660||6604026||Ysgol Uwchradd Caergybi
GwE||Isle of Anglesey County Council||660||6604027||Ysgol Gyfun Llangefni
GwE||Isle of Anglesey County Council||660||6604028||Ysgol David Hughes
GwE||Isle of Anglesey County Council||660||6604029||Ysgol Uwchradd Bodedern
GwE||Isle of Anglesey County Council||660||6605200||Ysgol Gynradd Caergeiliog
GwE||Isle of Anglesey County Council||660||6607011||Canolfan Addysg Y Bont
GwE||Gwynedd Council||661||6611104||Llechan Lân Centres
GwE||Gwynedd Council||661||6611105||Camu i’r Copa
GwE||Gwynedd Council||661||6612000||Ysgol Gwaun Gynfi
GwE||Gwynedd Council||661||6612004||Ysgol Gynradd Nefyn
GwE||Gwynedd Council||661||6612006||Ysgol Gynradd Llanrug
GwE||Gwynedd Council||661||6612008||Ysgol Gynradd Abererch
GwE||Gwynedd Council||661||6612010||Ysgol Gynradd Beddgelert
GwE||Gwynedd Council||661||6612011||Ysgol Gynradd Bethel
GwE||Gwynedd Council||661||6612013||Ysgol Bodfeurig
GwE||Gwynedd Council||661||6612015||Ysgol Gynradd Borth-Y-Gest
GwE||Gwynedd Council||661||6612017||Ysgol Brynaerau
GwE||Gwynedd Council||661||6612026||Ysgol Y Gelli
GwE||Gwynedd Council||661||6612028||Ysgol Penybryn
GwE||Gwynedd Council||661||6612033||Ysgol Treferthyr
GwE||Gwynedd Council||661||6612036||Ysgol Gynradd Chwilog
GwE||Gwynedd Council||661||6612039||Ysgol Crud-Y-Werin
GwE||Gwynedd Council||661||6612042||Ysgol Dolbadarn
GwE||Gwynedd Council||661||6612046||Ysgol Gynradd Edern
GwE||Gwynedd Council||661||6612048||Ysgol Bro Plenydd
GwE||Gwynedd Council||661||6612049||Ysgol Gynradd Garndolbenmaen
GwE||Gwynedd Council||661||6612060||Ysgol Gynradd Llanbedrog
GwE||Gwynedd Council||661||6612066||Ysgol Gynradd Llangybi
GwE||Gwynedd Council||661||6612069||Ysgol Gynradd Llanllechid
GwE||Gwynedd Council||661||6612070||Ysgol Gynradd Llanllyfni
GwE||Gwynedd Council||661||6612075||Ysgol Babanod Morfa Nefyn
GwE||Gwynedd Council||661||6612078||Ysgol Baladeulyn
GwE||Gwynedd Council||661||6612081||Ysgol Gynradd Nebo
GwE||Gwynedd Council||661||6612085||Ysgol Gymuned Penisarwaun
GwE||Gwynedd Council||661||6612089||Ysgol Bro Lleu
GwE||Gwynedd Council||661||6612093||Ysgol Gynradd Pentreuchaf
GwE||Gwynedd Council||661||6612097||Ysgol Gynradd Rhiwlas
GwE||Gwynedd Council||661||6612098||Ysgol Gynradd Rhosgadfan
GwE||Gwynedd Council||661||6612099||Ysgol Gynradd Rhostryfan
GwE||Gwynedd Council||661||6612103||Ysgol Sarn Bach
GwE||Gwynedd Council||661||6612104||Ysgol Eifion Wyn
GwE||Gwynedd Council||661||6612108||Ysgol Gynradd Talysarn
GwE||Gwynedd Council||661||6612110||Ysgol Y Gorlan
GwE||Gwynedd Council||661||6612111||Ysgol Yr Eifl
GwE||Gwynedd Council||661||6612112||Ysgol Gynradd Tudweiliog
GwE||Gwynedd Council||661||6612113||Ysgol Waunfawr
GwE||Gwynedd Council||661||6612116||Ysgol Glancegin
GwE||Gwynedd Council||661||6612119||Ysgol Yr Hendre
GwE||Gwynedd Council||661||6612122||Ysgol Gynradd Bontnewydd
GwE||Gwynedd Council||661||6612123||Ysgol Gymraeg Y Garnedd
GwE||Gwynedd Council||661||6612125||Ysgol Cymerau
GwE||Gwynedd Council||661||6612126||Ysgol Abercaseg (Babanod)
GwE||Gwynedd Council||661||6612127||Ysgol Gynradd y Felinheli
GwE||Gwynedd Council||661||6612181||Ysgol y Traeth
GwE||Gwynedd Council||661||6612185||Ysgol Gynradd Dyffryn Dulas
GwE||Gwynedd Council||661||6612189||Ysgol Gynradd Dyffryn Ardudwy
GwE||Gwynedd Council||661||6612190||Ysgol Bro Cynfal
GwE||Gwynedd Council||661||6612192||Ysgol Edmwnd Prys
GwE||Gwynedd Council||661||6612194||Ysgol Gynradd Llanbedr
GwE||Gwynedd Council||661||6612198||Ysgol Y Garreg
GwE||Gwynedd Council||661||6612199||Ysgol O M Edwards
GwE||Gwynedd Council||661||6612205||Ysgol Manod
GwE||Gwynedd Council||661||6612207||Ysgol Gynradd Pennal
GwE||Gwynedd Council||661||6612208||Ysgol Cefn Coch
GwE||Gwynedd Council||661||6612210||Ysgol Gynradd Talsarnau
GwE||Gwynedd Council||661||6612211||Ysgol Gynradd Tanygrisiau
GwE||Gwynedd Council||661||6612212||Ysgol Gynradd Penybryn
GwE||Gwynedd Council||661||6612213||Ysgol Bro Hedd Wyn
GwE||Gwynedd Council||661||6612214||Ysgol Bro Tryweryn
GwE||Gwynedd Council||661||6612219||Ysgol Tanycastell
GwE||Gwynedd Council||661||6612220||Ysgol Ffridd Y Llyn
GwE||Gwynedd Council||661||6612221||Ysgol Maenofferen
GwE||Gwynedd Council||661||6612227||Ysgol Gynradd Hirael
GwE||Gwynedd Council||661||6612228||Ysgol Craig y Deryn
GwE||Gwynedd Council||661||6612229||Ysgol Bro Llifon
GwE||Gwynedd Council||661||6613004||Ysgol Pont Y Gof
GwE||Gwynedd Council||661||6613005||Ysgol Gynradd Maesincla
GwE||Gwynedd Council||661||6613009||Ysgol Y Faenol
GwE||Gwynedd Council||661||6613010||Ysgol Foel Gron
GwE||Gwynedd Council||661||6613013||Ysgol Llandygai
GwE||Gwynedd Council||661||6613018||Ysgol Gynradd Llandwrog
GwE||Gwynedd Council||661||6613023||Ysgol Gynradd Llanystumdwy
GwE||Gwynedd Council||661||6613029||Ysgol Tregarth
GwE||Gwynedd Council||661||6613030||Ysgol Cae Top
GwE||Gwynedd Council||661||6613300||Ysgol Santes Helen
GwE||Gwynedd Council||661||6613301||Ysgol Ein Harglwyddes
GwE||Gwynedd Council||661||6614002||Ysgol Dyffryn Ogwen
GwE||Gwynedd Council||661||6614003||Ysgol Botwnnog
GwE||Gwynedd Council||661||6614004||Ysgol Brynrefail
GwE||Gwynedd Council||661||6614007||Ysgol Dyffryn Nantlle
GwE||Gwynedd Council||661||6614009||Ysgol Eifionydd
GwE||Gwynedd Council||661||6614031||Ysgol Y Moelwyn
GwE||Gwynedd Council||661||6614032||Ysgol Uwchradd Tywyn
GwE||Gwynedd Council||661||6614034||Ysgol Ardudwy
GwE||Gwynedd Council||661||6614036||Ysgol Friars
GwE||Gwynedd Council||661||6614037||Ysgol Tryfan
GwE||Gwynedd Council||661||6614039||Ysgol Syr Hugh Owen
GwE||Gwynedd Council||661||6614040||Ysgol Glan Y Mor
GwE||Gwynedd Council||661||6615500||Ysgol Bro Idris
GwE||Gwynedd Council||661||6615501||Ysgol Godre'r Berwyn
GwE||Gwynedd Council||661||6617002||Ysgol Pendalar
GwE||Gwynedd Council||661||6617010||Ysgol Hafod Lon
GwE||Conwy County Borough Council||662||6621100||Canolfan Addysg Nant-y-Bryniau Education Centre
GwE||Conwy County Borough Council||662||6621109||Canolfan Addysg Conwy
GwE||Conwy County Borough Council||662||6622012||Ysgol Betws Y Coed
GwE||Conwy County Borough Council||662||6622023||Ysgol Capelulo
GwE||Conwy County Borough Council||662||6622038||Ysgol Deganwy
GwE||Conwy County Borough Council||662||6622043||Ysgol Gynradd Dolwyddelan
GwE||Conwy County Borough Council||662||6622044||Ysgol Ffordd Dyffryn
GwE||Conwy County Borough Council||662||6622053||Ysgol Glanwydden
GwE||Conwy County Borough Council||662||6622061||Ysgol Tudno
GwE||Conwy County Borough Council||662||6622063||Ysgol Morfa Rhianedd
GwE||Conwy County Borough Council||662||6622086||Ysgol Penmachno
GwE||Conwy County Borough Council||662||6622103||Ysgol Llandrillo yn Rhos
GwE||Conwy County Borough Council||662||6622104||Ysgol Talhaiarn
GwE||Conwy County Borough Council||662||6622108||Ysgol T Gwynn Jones
GwE||Conwy County Borough Council||662||6622110||Ysgol Maes Owen
GwE||Conwy County Borough Council||662||6622111||Ysgol Glan Gele
GwE||Conwy County Borough Council||662||6622112||Ysgol Glan Morfa
GwE||Conwy County Borough Council||662||6622114||Ysgol Bod Alaw
GwE||Conwy County Borough Council||662||6622115||Ysgol Pant-Y-Rhedyn
GwE||Conwy County Borough Council||662||6622118||Ysgol Y Foryd
GwE||Conwy County Borough Council||662||6622121||Ysgol Craig Y Don
GwE||Conwy County Borough Council||662||6622123||Ysgol Gynradd Cerrigydrudion
GwE||Conwy County Borough Council||662||6622132||Ysgol Bro Aled, Llansannan
GwE||Conwy County Borough Council||662||6622148||Ysgol Gynradd Bro Cernyw
GwE||Conwy County Borough Council||662||6622221||Ysgol Sant Elfod
GwE||Conwy County Borough Council||662||6622222||Ysgol Capel Garmon
GwE||Conwy County Borough Council||662||6622225||Ysgol Glan Conwy
GwE||Conwy County Borough Council||662||6622264||Ysgol Cynfran
GwE||Conwy County Borough Council||662||6622267||Ysgol Iau Hen Golwyn
GwE||Conwy County Borough Council||662||6622270||Ysgol Pentrefoelas
GwE||Conwy County Borough Council||662||6622271||Ysgol Bro Gwydir
GwE||Conwy County Borough Council||662||6622272||Ysgol Nant Y Groes
GwE||Conwy County Borough Council||662||6622273||Ysgol Swn Y Don
GwE||Conwy County Borough Council||662||6622274||Ysgol Awel y Mynydd
GwE||Conwy County Borough Council||662||6622275||Ysgol Dyffryn Yr Enfys
GwE||Conwy County Borough Council||662||6622276||Ysgol Minafon
GwE||Conwy County Borough Council||662||6623020||Ysgol Babanod Llanfairfechan
GwE||Conwy County Borough Council||662||6623021||Ysgol Llangelynnin
GwE||Conwy County Borough Council||662||6623024||Ysgol Pencae (Penmaenmawr)
GwE||Conwy County Borough Council||662||6623032||Ysgol Ysbyty Ifan
GwE||Conwy County Borough Council||662||6623038||Ysgol St. George
GwE||Conwy County Borough Council||662||6623039||Ysgol Llanddoged
GwE||Conwy County Borough Council||662||6623040||Ysgol Eglwysbach
GwE||Conwy County Borough Council||662||6623043||Ysgol Porth y Felin
GwE||Conwy County Borough Council||662||6623059||Ysgol Llanddulas
GwE||Conwy County Borough Council||662||6623062||Ysgol Betws yn Rhos
GwE||Conwy County Borough Council||662||6623302||Ysgol Bodafon
GwE||Conwy County Borough Council||662||6623303||Ysgol Bendigaid William Davies
GwE||Conwy County Borough Council||662||6623307||Ysgol San Sior
GwE||Conwy County Borough Council||662||6623333||Ysgol Sant Joseph
GwE||Conwy County Borough Council||662||6623340||Ysgol y Plas
GwE||Conwy County Borough Council||662||6624022||Ysgol John Bright
GwE||Conwy County Borough Council||662||6624023||Ysgol Aberconwy
GwE||Conwy County Borough Council||662||6624035||Ysgol Dyffryn Conwy
GwE||Conwy County Borough Council||662||6624038||Ysgol Y Creuddyn
GwE||Conwy County Borough Council||662||6625201||Ysgol Pen y Bryn
GwE||Conwy County Borough Council||662||6625400||Ysgol Emrys Ap Iwan
GwE||Conwy County Borough Council||662||6625402||Eirias High School
GwE||Conwy County Borough Council||662||6625403||Ysgol Bryn Elian
GwE||Conwy County Borough Council||662||6627007||Ysgol Y Gogarth
GwE||Denbighshire County Council||663||6631100||Denbighshire PRUs
GwE||Denbighshire County Council||663||6632011||Ysgol Hiraddug
GwE||Denbighshire County Council||663||6632037||Ysgol y Castell CP School
GwE||Denbighshire County Council||663||6632038||Christchurch CP School
GwE||Denbighshire County Council||663||6632039||Ysgol Llywelyn
GwE||Denbighshire County Council||663||6632057||Ysgol Y Faenol
GwE||Denbighshire County Council||663||6632059||Ysgol Penmorfa
GwE||Denbighshire County Council||663||6632060||Ysgol Emmanuel
GwE||Denbighshire County Council||663||6632066||Ysgol Dewi Sant
GwE||Denbighshire County Council||663||6632067||Ysgol Melyd
GwE||Denbighshire County Council||663||6632070||Ysgol Bodfari
GwE||Denbighshire County Council||663||6632072||Ysgol Bryn Hedydd
GwE||Denbighshire County Council||663||6632124||Ysgol Cefn Meiriadog
GwE||Denbighshire County Council||663||6632125||Ysgol Frongoch
GwE||Denbighshire County Council||663||6632127||Ysgol Henllan
GwE||Denbighshire County Council||663||6632134||Ysgol Twm o'r Nant
GwE||Denbighshire County Council||663||6632135||Ysgol Bryn Clwyd
GwE||Denbighshire County Council||663||6632136||Ysgol Y Parc
GwE||Denbighshire County Council||663||6632164||Ysgol Gellifor
GwE||Denbighshire County Council||663||6632168||Ysgol Gynradd Pentrecelyn
GwE||Denbighshire County Council||663||6632214||Ysgol Betws Gwerful Goch
GwE||Denbighshire County Council||663||6632215||Ysgol Carrog
GwE||Denbighshire County Council||663||6632216||Ysgol Caer Drewyn
GwE||Denbighshire County Council||663||6632219||Ysgol Bro Elwern
GwE||Denbighshire County Council||663||6632227||Ysgol Y Llys
GwE||Denbighshire County Council||663||6632234||Ysgol Bryn Collen
GwE||Denbighshire County Council||663||6632255||Rhos Street CP School
GwE||Denbighshire County Council||663||6632256||Ysgol Pen Barras
GwE||Denbighshire County Council||663||6632261||Ysgol Bro Cinmeirch
GwE||Denbighshire County Council||663||6632262||Ysgol Bro Famau
GwE||Denbighshire County Council||663||6632263||Ysgol Gymraeg Y Gwernant
GwE||Denbighshire County Council||663||6632264||Ysgol Clawdd Offa
GwE||Denbighshire County Council||663||6632265||Bodnant Community primarySchool
GwE||Denbighshire County Council||663||6632266||Ysgol Pendref
GwE||Denbighshire County Council||663||6632267||Ysgol Bro Dyfrdwy
GwE||Denbighshire County Council||663||6632268||Ysgol Carreg Emlyn
GwE||Denbighshire County Council||663||6633020||Ysgol Tremeirchion
GwE||Denbighshire County Council||663||6633024||St Asaph Infants School
GwE||Denbighshire County Council||663||6633044||Ysgol Llanbedr
GwE||Denbighshire County Council||663||6633045||Ysgol Llanfair Dyffryn Clwyd
GwE||Denbighshire County Council||663||6633050||Ysgol Borthyn
GwE||Denbighshire County Council||663||6633057||Ysgol Pant Pastynog
GwE||Denbighshire County Council||663||6633061||Ysgol Dyffryn Ial
GwE||Denbighshire County Council||663||6633062||Ysgol Esgob Morgan CiW VC primarySchool
GwE||Denbighshire County Council||663||6633316||Ysgol Trefnant
GwE||Denbighshire County Council||663||6634003||Rhyl High School
GwE||Denbighshire County Council||663||6634014||Prestatyn High School
GwE||Denbighshire County Council||663||6634020||Ysgol Uwchradd Glan Clwyd
GwE||Denbighshire County Council||663||6634026||Denbigh High School
GwE||Denbighshire County Council||663||6634027||Ysgol Dinas Bran
GwE||Denbighshire County Council||663||6634031||Ysgol Brynhyfryd
GwE||Denbighshire County Council||663||6635901||St Brigid's School
GwE||Denbighshire County Council||663||6635902||Christ the Word Catholic School
GwE||Denbighshire County Council||663||6637000||Ysgol Tir Morfa
GwE||Denbighshire County Council||663||6637010||Ysgol Plas Brondyffryn
GwE||Flintshire County Council||664||6641102||Flintshire Portfolio PRU's
GwE||Flintshire County Council||664||6642002||Ysgol Glan Aber
GwE||Flintshire County Council||664||6642003||Ysgol Merllyn
GwE||Flintshire County Council||664||6642004||Westwood Community primarySchool
GwE||Flintshire County Council||664||6642012||Ewloe Green CP School
GwE||Flintshire County Council||664||6642013||Ysgol Bryn Garth
GwE||Flintshire County Council||664||6642015||Ysgol Gwynedd
GwE||Flintshire County Council||664||6642018||Ysgol Maesglas
GwE||Flintshire County Council||664||6642021||Ysgol Gymraeg Mornant
GwE||Flintshire County Council||664||6642024||Ysgol Estyn CP School
GwE||Flintshire County Council||664||6642028||Ysgol Glanrafon
GwE||Flintshire County Council||664||6642032||Northop Hall CP School
GwE||Flintshire County Council||664||6642040||Wood Memorial CP School
GwE||Flintshire County Council||664||6642041||Sealand CP School
GwE||Flintshire County Council||664||6642043||Sychdyn CP School
GwE||Flintshire County Council||664||6642044||Ysgol Gynradd Trelogan
GwE||Flintshire County Council||664||6642046||Ysgol Bryn Pennant
GwE||Flintshire County Council||664||6642049||Ysgol Bro Carmel
GwE||Flintshire County Council||664||6642050||Ysgol Rhos Helyg
GwE||Flintshire County Council||664||6642051||Ysgol Terrig
GwE||Flintshire County Council||664||6642052||Ysgol Bryn Deva
GwE||Flintshire County Council||664||6642053||Sandycroft CP School
GwE||Flintshire County Council||664||6642056||Gwernymynydd CP School
GwE||Flintshire County Council||664||6642061||Queensferry CP School
GwE||Flintshire County Council||664||6642062||Ysgol Bryn Coch
GwE||Flintshire County Council||664||6642063||Mountain Lane CP School
GwE||Flintshire County Council||664||6642064||Ysgol Y Foel
GwE||Flintshire County Council||664||6642065||Brynford CP School
GwE||Flintshire County Council||664||6642068||Ysgol Bryn Gwalia
GwE||Flintshire County Council||664||6642077||Golftyn CP School
GwE||Flintshire County Council||664||6642078||Saltney Ferry CP School
GwE||Flintshire County Council||664||6642081||Ysgol Y Waun
GwE||Flintshire County Council||664||6642082||Ysgol Gwenffrwd
GwE||Flintshire County Council||664||6642084||Abermorddu CP School
GwE||Flintshire County Council||664||6642085||Southdown CP School
GwE||Flintshire County Council||664||6642086||Wepre CP School
GwE||Flintshire County Council||664||6642089||Drury primarySchool
GwE||Flintshire County Council||664||6642091||Cornist Park CP School
GwE||Flintshire County Council||664||6642092||Ysgol Derwenfa
GwE||Flintshire County Council||664||6642093||Penarlag CP School
GwE||Flintshire County Council||664||6642094||Ysgol Owen Jones
GwE||Flintshire County Council||664||6642237||Ysgol Gronant
GwE||Flintshire County Council||664||6642257||Ysgol Croes Atti
GwE||Flintshire County Council||664||6642266||Ysgol Parc Y Llan
GwE||Flintshire County Council||664||6642267||Ysgol Mynydd Isa
GwE||Flintshire County Council||664||6642268||Broughton primarySchool
GwE||Flintshire County Council||664||6642269||Ysgol Cae'r Nant
GwE||Flintshire County Council||664||6642270||Ysgol Penyffordd
GwE||Flintshire County Council||664||6642271||Ysgol Ty Ffynnon
GwE||Flintshire County Council||664||6642272||Ysgol Maes y Felin
GwE||Flintshire County Council||664||6643002||Nannerch VCP School
GwE||Flintshire County Council||664||6643303||Ysgol Yr Esgob CiW
GwE||Flintshire County Council||664||6643306||St Mary's RC primarySchool
GwE||Flintshire County Council||664||6643307||St Winefrides RC School
GwE||Flintshire County Council||664||6643308||St David's Catholic School
GwE||Flintshire County Council||664||6643311||St Anthony's Catholic primarySchool
GwE||Flintshire County Council||664||6643312||Ven. Edward Morgan RC primarySchool
GwE||Flintshire County Council||664||6643316||Trelawnyd VA School
GwE||Flintshire County Council||664||6643320||Ysgol Y Llan VA primarySchool (Whitford)
GwE||Flintshire County Council||664||6643330||St Ethelwold's primarySchool
GwE||Flintshire County Council||664||6643331||St John the Baptist VA primarySchool
GwE||Flintshire County Council||664||6643332||Nercwys CiW Voluntary Aided primarySchool
GwE||Flintshire County Council||664||6643333||Hawarden Village Church School
GwE||Flintshire County Council||664||6643334||Lixwm CiW VA School
GwE||Flintshire County Council||664||6644000||Hawarden High School
GwE||Flintshire County Council||664||6644006||Alun School
GwE||Flintshire County Council||664||6644011||Elfed High School
GwE||Flintshire County Council||664||6644012||Ysgol Treffynnon
GwE||Flintshire County Council||664||6644013||St David's High School
GwE||Flintshire County Council||664||6644017||Castell Alun High School
GwE||Flintshire County Council||664||6644018||Ysgol Maes Garmon
GwE||Flintshire County Council||664||6644021||Flint High School
GwE||Flintshire County Council||664||6644022||Connah's Quay High School
GwE||Flintshire County Council||664||6644042||Argoed High School
GwE||Flintshire County Council||664||6644600||St Richard Gwyn Catholic High School
GwE||Flintshire County Council||664||6645200||Derwen Foundation School
GwE||Flintshire County Council||664||6647020||Ysgol Pen Coch
GwE||Flintshire County Council||664||6647021||Ysgol Maes Hyfryd
GwE||Wrexham County Borough Council||665||6651104||Wrexham Pupil Referral Services
GwE||Wrexham County Borough Council||665||6652076||The Rofft CP School
GwE||Wrexham County Borough Council||665||6652137||Froncysyllte CP School
GwE||Wrexham County Borough Council||665||6652138||Garth CP School
GwE||Wrexham County Borough Council||665||6652139||Ysgol Cynddelw
GwE||Wrexham County Borough Council||665||6652140||Ysgol Llanarmon DC
GwE||Wrexham County Borough Council||665||6652149||Ysgol Acrefair
GwE||Wrexham County Borough Council||665||6652151||Cefn Mawr CP School
GwE||Wrexham County Borough Council||665||6652160||Ysgol Maes y Llan
GwE||Wrexham County Borough Council||665||6652162||Ysgol Min y Ddol
GwE||Wrexham County Borough Council||665||6652173||Alexandra CP School
GwE||Wrexham County Borough Council||665||6652176||Brynteg CP School
GwE||Wrexham County Borough Council||665||6652178||Bwlchgwyn School
GwE||Wrexham County Borough Council||665||6652179||Ysgol Tan-y-Fron
GwE||Wrexham County Borough Council||665||6652187||Black Lane CP School
GwE||Wrexham County Borough Council||665||6652191||Rhosddu primarySchool
GwE||Wrexham County Borough Council||665||6652200||Ysgol Rhostyllen
GwE||Wrexham County Borough Council||665||6652204||Ysgol Deiniol CP
GwE||Wrexham County Borough Council||665||6652208||Barker's Lane CP School
GwE||Wrexham County Borough Council||665||6652209||Wat's Dyke CP School
GwE||Wrexham County Borough Council||665||6652224||Ysgol Bryn Tabor
GwE||Wrexham County Borough Council||665||6652232||Ysgol Sant Dunawd
GwE||Wrexham County Borough Council||665||6652235||Holt CP School
GwE||Wrexham County Borough Council||665||6652238||Ysgol Bodhyfryd
GwE||Wrexham County Borough Council||665||6652259||Ysgol ID Hooson
GwE||Wrexham County Borough Council||665||6652263||Ysgol Plas Coch
GwE||Wrexham County Borough Council||665||6652266||Penygelli CP Primary
GwE||Wrexham County Borough Council||665||6652267||Ysgol Penrhyn New Broughton Primary
GwE||Wrexham County Borough Council||665||6652268||Ysgol Heulfan
GwE||Wrexham County Borough Council||665||6652269||Hafod -Y- Wern Community primarySchool
GwE||Wrexham County Borough Council||665||6652270||Gwenfro Community primarySchool
GwE||Wrexham County Borough Council||665||6652271||Park Community primarySchool (Llay)
GwE||Wrexham County Borough Council||665||6652272||Rhosymedre Community primarySchool
GwE||Wrexham County Borough Council||665||6652273||Ysgol Maes y Mynydd
GwE||Wrexham County Borough Council||665||6652274||Gwersyllt CP School
GwE||Wrexham County Borough Council||665||6652275||Penycae CP School
GwE||Wrexham County Borough Council||665||6652276||Acton Primary
GwE||Wrexham County Borough Council||665||6652277||Victoria primarySchool
GwE||Wrexham County Borough Council||665||6652278||Ysgol y Waun
GwE||Wrexham County Borough Council||665||6652279||Ysgol Bro Alun
GwE||Wrexham County Borough Council||665||6652280||Ysgol Yr Hafod, Johnstown
GwE||Wrexham County Borough Council||665||6652281||Borras Park CP School
GwE||Wrexham County Borough Council||665||6652282||Ysgol Llan-y-Pwll
GwE||Wrexham County Borough Council||665||6653028||St Peter's CiW VC primarySchool
GwE||Wrexham County Borough Council||665||6653036||Pentre CiW VC primarySchool
GwE||Wrexham County Borough Council||665||6653042||Eyton primarySchool
GwE||Wrexham County Borough Council||665||6653054||Borderbrook School
GwE||Wrexham County Borough Council||665||6653055||St Giles VC Church in Wales primarySchool
GwE||Wrexham County Borough Council||665||6653301||Bronington CiW VA Primary
GwE||Wrexham County Borough Council||665||6653305||Madras VA primarySchool
GwE||Wrexham County Borough Council||665||6653326||St Chad's CiW VA primarySchool
GwE||Wrexham County Borough Council||665||6653334||St Mary's RC primarySchool
GwE||Wrexham County Borough Council||665||6653337||Minera VA primarySchool
GwE||Wrexham County Borough Council||665||6653338||All Saints VA primarySchool
GwE||Wrexham County Borough Council||665||6653341||St Mary's CiW primarySchool (Ruabon)
GwE||Wrexham County Borough Council||665||6653342||Brymbo Aided (St Mary's)
GwE||Wrexham County Borough Council||665||6653343||St Anne's Catholic primarySchool
GwE||Wrexham County Borough Council||665||6653346||St Mary's CiW VA School
GwE||Wrexham County Borough Council||665||6653347||St Paul's VA School
GwE||Wrexham County Borough Council||665||6654029||Ysgol y Grango
GwE||Wrexham County Borough Council||665||6654032||Ysgol Morgan Llwyd
GwE||Wrexham County Borough Council||665||6654033||Ysgol Bryn Alyn
GwE||Wrexham County Borough Council||665||6654034||Darland High School
GwE||Wrexham County Borough Council||665||6654044||Ysgol Rhiwabon
GwE||Wrexham County Borough Council||665||6654048||Rhosnesni High School
GwE||Wrexham County Borough Council||665||6654049||Ysgol Clywedog
GwE||Wrexham County Borough Council||665||6654603||St Joseph's Catholic and Anglican High School
GwE||Wrexham County Borough Council||665||6655401||The Maelor School
GwE||Wrexham County Borough Council||665||6657005||St Christopher's School
GwE||Wrexham County Borough Council||665||6657018||Ysgol Cae'r Gwenyn
Mid Wales Partnership||Powys County Council||666||6661103||Powys PRU
Mid Wales Partnership||Powys County Council||666||6661104||Powys PRU- Brecon
Mid Wales Partnership||Powys County Council||666||6662002||Abermule CP School
Mid Wales Partnership||Powys County Council||666||6662003||Arddleen CP School
Mid Wales Partnership||Powys County Council||666||6662005||Berriew CP School
Mid Wales Partnership||Powys County Council||666||6662008||Caersws CP School
Mid Wales Partnership||Powys County Council||666||6662009||Ysgol Gynradd Carno
Mid Wales Partnership||Powys County Council||666||6662010||Carreghofa CP School
Mid Wales Partnership||Powys County Council||666||6662018||Leighton CP School
Mid Wales Partnership||Powys County Council||666||6662019||Ysgol Llanbrynmair
Mid Wales Partnership||Powys County Council||666||6662020||Llandinam CP School
Mid Wales Partnership||Powys County Council||666||6662033||Meifod CP School
Mid Wales Partnership||Powys County Council||666||6662040||Penygloddfa CP School
Mid Wales Partnership||Powys County Council||666||6662041||Pontrobert CP School
Mid Wales Partnership||Powys County Council||666||6662044||Ysgol Dyffryn Trannon
Mid Wales Partnership||Powys County Council||666||6662049||Guilsfield CP School
Mid Wales Partnership||Powys County Council||666||6662050||Llanidloes CP School
Mid Wales Partnership||Powys County Council||666||6662051||Buttington / Trewern CP School
Mid Wales Partnership||Powys County Council||666||6662053||Brynhafren CP School
Mid Wales Partnership||Powys County Council||666||6662054||Churchstoke CP School
Mid Wales Partnership||Powys County Council||666||6662058||Ysgol Gynradd Glantwymyn
Mid Wales Partnership||Powys County Council||666||6662059||Ysgol Pennant
Mid Wales Partnership||Powys County Council||666||6662060||Maesyrhandir CP School
Mid Wales Partnership||Powys County Council||666||6662066||Franksbridge CP School
Mid Wales Partnership||Powys County Council||666||6662068||Llanbister CP School
Mid Wales Partnership||Powys County Council||666||6662070||Ysgol Cefnllys
Mid Wales Partnership||Powys County Council||666||6662075||Presteigne CP School
Mid Wales Partnership||Powys County Council||666||6662076||Radnor Valley CP School
Mid Wales Partnership||Powys County Council||666||6662077||Crossgates CP School
Mid Wales Partnership||Powys County Council||666||6662084||Ysgol Dolafon
Mid Wales Partnership||Powys County Council||666||6662089||Builth Wells CP School
Mid Wales Partnership||Powys County Council||666||6662092||Sennybridge CP School
Mid Wales Partnership||Powys County Council||666||6662113||Crickhowell CP School
Mid Wales Partnership||Powys County Council||666||6662116||Hay-on-Wye CP School
Mid Wales Partnership||Powys County Council||666||6662117||Llangynidr CP School
Mid Wales Partnership||Powys County Council||666||6662125||Llanfaes CP School
Mid Wales Partnership||Powys County Council||666||6662127||Ysgol y Bannau
Mid Wales Partnership||Powys County Council||666||6662129||Ysgol Rhiw Bechan
Mid Wales Partnership||Powys County Council||666||6662146||Llanrhaeadr ym Mochnant CP School
Mid Wales Partnership||Powys County Council||666||6662148||Ysgol Dafydd Llwyd
Mid Wales Partnership||Powys County Council||666||6662149||Ysgol y Cribarth
Mid Wales Partnership||Powys County Council||666||6662150||Ysgol Golwg y Cwm
Mid Wales Partnership||Powys County Council||666||6662151||Ysgol Bro Tawe
Mid Wales Partnership||Powys County Council||666||6662152||Ysgol Gymraeg Dyffryn y Glowyr
Mid Wales Partnership||Powys County Council||666||6662153||Ysgol y Mynydd Du
Mid Wales Partnership||Powys County Council||666||6662154||Ysgol Gymraeg y Trallwng
Mid Wales Partnership||Powys County Council||666||6662155||Ysgol Calon y Dderwen
Mid Wales Partnership||Powys County Council||666||6662156||Ysgol Golwg Pen y Fan 
Mid Wales Partnership||Powys County Council||666||6663000||Llanfechain CiW School
Mid Wales Partnership||Powys County Council||666||6663002||Montgomery CiW School
Mid Wales Partnership||Powys County Council||666||6663016||Forden CiW School
Mid Wales Partnership||Powys County Council||666||6663021||Llandysilio CiW School
Mid Wales Partnership||Powys County Council||666||6663026||Gladestry CiW School
Mid Wales Partnership||Powys County Council||666||6663030||Llandrindod Wells CiW School Trefonnen
Mid Wales Partnership||Powys County Council||666||6663031||Newbridge-on-Wye CiW School
Mid Wales Partnership||Powys County Council||666||6663033||Clyro CiW School
Mid Wales Partnership||Powys County Council||666||6663035||Knighton CiW School
Mid Wales Partnership||Powys County Council||666||6663036||Rhayader CiW School
Mid Wales Partnership||Powys County Council||666||6663037||Llanelwedd CiW School
Mid Wales Partnership||Powys County Council||666||6663050||Llangors CiW School
Mid Wales Partnership||Powys County Council||666||6663051||Welshpool CiW primarySchool
Mid Wales Partnership||Powys County Council||666||6663301||St. Michael's CiW School
Mid Wales Partnership||Powys County Council||666||6663303||Llansantffraid CiWA. School
Mid Wales Partnership||Powys County Council||666||6663317||Archdeacon Griffiths CiW primarySchool
Mid Wales Partnership||Powys County Council||666||6663318||Priory CiW School
Mid Wales Partnership||Powys County Council||666||6663320||St Mary's RC (A) School
Mid Wales Partnership||Powys County Council||666||6663322||Llangattock CiW Voluntary Aided
Mid Wales Partnership||Powys County Council||666||6663323||Ysgol Cwm Banwy
Mid Wales Partnership||Powys County Council||666||6664002||Llanidloes High School
Mid Wales Partnership||Powys County Council||666||6664011||Newtown High School
Mid Wales Partnership||Powys County Council||666||6664013||Welshpool High School
Mid Wales Partnership||Powys County Council||666||6664021||Ysgol Maes-y-Dderwen
Mid Wales Partnership||Powys County Council||666||6664022||Brecon High School
Mid Wales Partnership||Powys County Council||666||6664023||Gwernyfed High School
Mid Wales Partnership||Powys County Council||666||6664024||Crickhowell High School
Mid Wales Partnership||Powys County Council||666||6664025||Ysgol Calon Cymru
Mid Wales Partnership||Powys County Council||666||6665500||Ysgol Bro Hyddgen
Mid Wales Partnership||Powys County Council||666||6665501||Ysgol Llanfyllin
Mid Wales Partnership||Powys County Council||666||6665502||Ysgol Bro Caereinion
Mid Wales Partnership||Powys County Council||666||6667001||Brynllywarch Hall School
Mid Wales Partnership||Powys County Council||666||6667002||Ysgol Robert Owen
Mid Wales Partnership||Powys County Council||666||6667004||Ysgol Penmaes
Mid Wales Partnership||Ceredigion County Council||667||6671106||Ceredigion Pupil Referral Service
Mid Wales Partnership||Ceredigion County Council||667||6671234||Esgol
Mid Wales Partnership||Ceredigion County Council||667||6672281||Ysgol Gynradd Aberaeron
Mid Wales Partnership||Ceredigion County Council||667||6672291||Ysgol Gymunedol Llanarth
Mid Wales Partnership||Ceredigion County Council||667||6672293||Ysgol Gymunedol Llannon
Mid Wales Partnership||Ceredigion County Council||667||6672295||Ysgol Gymunedol Cei Newydd
Mid Wales Partnership||Ceredigion County Council||667||6672298||Ysgol Gymunedol Talgarreg
Mid Wales Partnership||Ceredigion County Council||667||6672299||Yr Ysgol Gymraeg Aberystwyth
Mid Wales Partnership||Ceredigion County Council||667||6672303||Ysgol Gymunedol Comins Coch
Mid Wales Partnership||Ceredigion County Council||667||6672308||Ysgol Gymunedol Llanfarian
Mid Wales Partnership||Ceredigion County Council||667||6672309||Ysgol Gymunedol Llanfihangel-y-Creuddyn
Mid Wales Partnership||Ceredigion County Council||667||6672310||Ysgol Gymunedol Llangwyryfon
Mid Wales Partnership||Ceredigion County Council||667||6672311||Ysgol Gymunedol Llanilar
Mid Wales Partnership||Ceredigion County Council||667||6672312||Ysgol Gymunedol Mynach
Mid Wales Partnership||Ceredigion County Council||667||6672313||Ysgol Gymunedol Penllwyn
Mid Wales Partnership||Ceredigion County Council||667||6672314||Ysgol Gymunedol Llwynyreos
Mid Wales Partnership||Ceredigion County Council||667||6672315||Ysgol Gymunedol Syr John Rhys
Mid Wales Partnership||Ceredigion County Council||667||6672316||Ysgol Gymunedol Rhydypennau
Mid Wales Partnership||Ceredigion County Council||667||6672317||Ysgol Gymunedol Talybont
Mid Wales Partnership||Ceredigion County Council||667||6672319||Ysgol Gymunedol Aberporth
Mid Wales Partnership||Ceredigion County Council||667||6672323||Ysgol Gymunedol Llechryd
Mid Wales Partnership||Ceredigion County Council||667||6672324||Ysgol Gymunedol Penparc
Mid Wales Partnership||Ceredigion County Council||667||6672353||Ysgol Gymunedol Pontrhydfendigaid
Mid Wales Partnership||Ceredigion County Council||667||6672361||Ysgol Gymunedol Plascrug
Mid Wales Partnership||Ceredigion County Council||667||6672362||Ysgol Gymunedol Craig Yr Wylfa
Mid Wales Partnership||Ceredigion County Council||667||6672363||Ysgol Gymunedol Penrhyncoch
Mid Wales Partnership||Ceredigion County Council||667||6672366||Ysgol Gymunedol Y Dderi
Mid Wales Partnership||Ceredigion County Council||667||6672367||Ysgol Gymunedol Cenarth
Mid Wales Partnership||Ceredigion County Council||667||6672368||Ysgol Gynradd Aberteifi
Mid Wales Partnership||Ceredigion County Council||667||6672369||Ysgol Bro Sion Cwilt
Mid Wales Partnership||Ceredigion County Council||667||6672371||Ysgol T Llew Jones
Mid Wales Partnership||Ceredigion County Council||667||6672372||Ysgol Rhos Helyg
Mid Wales Partnership||Ceredigion County Council||667||6672374||Dyffryn Aeron
Mid Wales Partnership||Ceredigion County Council||667||6673058||Ysgol Wirfoddol Myfenydd
Mid Wales Partnership||Ceredigion County Council||667||6673061||Ysgol Dyffryn Cledlyn
Mid Wales Partnership||Ceredigion County Council||667||6673318||Ysgol Gynradd Gatholig Padarn Sant
Mid Wales Partnership||Ceredigion County Council||667||6674042||Ysgol Gyfun Aberaeron
Mid Wales Partnership||Ceredigion County Council||667||6674044||Ysgol Uwchradd Aberteifi
Mid Wales Partnership||Ceredigion County Council||667||6674047||Penglais School
Mid Wales Partnership||Ceredigion County Council||667||6674048||Ysgol Gyfun Penweddig
Mid Wales Partnership||Ceredigion County Council||667||6675500||Ysgol Bro Pedr
Mid Wales Partnership||Ceredigion County Council||667||6675501||Ysgol Henry Richard
Mid Wales Partnership||Ceredigion County Council||667||6675502||Ysgol Bro Teifi
Y Partneriaeth||Pembrokeshire County Council||668||6681104||Pembrokeshire Learning Centre
Y Partneriaeth||Pembrokeshire County Council||668||6682203||Sageston CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682209||Ysgol Gymunedol Eglwyswrw
Y Partneriaeth||Pembrokeshire County Council||668||6682212||Ysgol Gymunedol Wdig
Y Partneriaeth||Pembrokeshire County Council||668||6682214||Fenton CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682220||Johnston CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682222||Lamphey primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6682223||Ysgol Gymunedol Brynconin
Y Partneriaeth||Pembrokeshire County Council||668||6682228||Hook CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682231||Ysgol Llanychllwydog
Y Partneriaeth||Pembrokeshire County Council||668||6682233||Ysgol Gymunedol Maenclochog
Y Partneriaeth||Pembrokeshire County Council||668||6682242||Narberth CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682243||Ysgol Bro Ingli
Y Partneriaeth||Pembrokeshire County Council||668||6682250||Puncheston CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682253||St Dogmaels CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682254||Wolfcastle CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682258||Saundersfoot CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682260||Stepaside CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682261||Templeton CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682266||Tavernspite CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682270||Ysgol Gymunedol Croesgoch
Y Partneriaeth||Pembrokeshire County Council||668||6682271||Broad Haven CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682273||Roch Community School
Y Partneriaeth||Pembrokeshire County Council||668||6682384||Coastlands CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682385||Ysgol Clydau
Y Partneriaeth||Pembrokeshire County Council||668||6682386||Pembroke Dock Community School
Y Partneriaeth||Pembrokeshire County Council||668||6682387||Monkton Priory CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682388||Ysgol Gelli Aur/Golden Grove
Y Partneriaeth||Pembrokeshire County Council||668||6682389||Ysgol Glannau Gwaun
Y Partneriaeth||Pembrokeshire County Council||668||6682391||Prendergast CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682392||Pennar Community School
Y Partneriaeth||Pembrokeshire County Council||668||6682393||Neyland Community School
Y Partneriaeth||Pembrokeshire County Council||668||6682395||Ysgol Hafan y Mor
Y Partneriaeth||Pembrokeshire County Council||668||6682396||Milford Haven CP School
Y Partneriaeth||Pembrokeshire County Council||668||6682397||Waldo Williams primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6682398||Ysgol Gymraeg Bro Penfro
Y Partneriaeth||Pembrokeshire County Council||668||6683035||Cilgerran CiW VCP School
Y Partneriaeth||Pembrokeshire County Council||668||6683036||Cosheston VCP School
Y Partneriaeth||Pembrokeshire County Council||668||6683040||Cleddau Reach VCP School
Y Partneriaeth||Pembrokeshire County Council||668||6683042||Manorbier VCP School
Y Partneriaeth||Pembrokeshire County Council||668||6683050||Spittal CiW VCP School
Y Partneriaeth||Pembrokeshire County Council||668||6683055||St Florence VC School
Y Partneriaeth||Pembrokeshire County Council||668||6683058||Ysgol Ger y Llan
Y Partneriaeth||Pembrokeshire County Council||668||6683059||Tenby VC School
Y Partneriaeth||Pembrokeshire County Council||668||6683060||Penrhyn CiW VC School
Y Partneriaeth||Pembrokeshire County Council||668||6683061||Gelliswick CiW VC primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6683311||Holy Name Catholic primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6683313||Mary Immaculate Catholic primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6683314||St Francis Catholic primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6683315||St Aidans VA School
Y Partneriaeth||Pembrokeshire County Council||668||6683319||St Teilos Catholic primarySchool
Y Partneriaeth||Pembrokeshire County Council||668||6683320||St Marks VA School
Y Partneriaeth||Pembrokeshire County Council||668||6683321||St Oswalds CiW VA School
Y Partneriaeth||Pembrokeshire County Council||668||6684031||Ysgol Bro Gwaun
Y Partneriaeth||Pembrokeshire County Council||668||6684035||Ysgol Greenhill School
Y Partneriaeth||Pembrokeshire County Council||668||6684038||Ysgol Harri Tudur
Y Partneriaeth||Pembrokeshire County Council||668||6684063||Milford Haven School
Y Partneriaeth||Pembrokeshire County Council||668||6684512||Haverfordwest VC High School
Y Partneriaeth||Pembrokeshire County Council||668||6685500||Ysgol Caer Elen
Y Partneriaeth||Pembrokeshire County Council||668||6685501||Ysgol Bro Preseli
Y Partneriaeth||Pembrokeshire County Council||668||6685900||Ysgol Penrhyn Dewi
Y Partneriaeth||Pembrokeshire County Council||668||6687001||Portfield School
Y Partneriaeth||Carmarthenshire County Counil||669||6691000||Ysgol Feithrin Rhydaman
Y Partneriaeth||Carmarthenshire County Counil||669||6691110||Carmarthenshire Secondary Teaching and Learning Centre
Y Partneriaeth||Carmarthenshire County Counil||669||6691111||Canolfan Bro Tywi
Y Partneriaeth||Carmarthenshire County Counil||669||6691112||Carmarthenshire Secondary Teaching and Learning Centre (Carmarthen)
Y Partneriaeth||Carmarthenshire County Counil||669||6692000||Cefneithin primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692001||Ysgol Gynradd Drefach
Y Partneriaeth||Carmarthenshire County Counil||669||6692003||Llechyfedach primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692006||Ysgol Y Tymbl
Y Partneriaeth||Carmarthenshire County Counil||669||6692007||Gorslas primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692008||Cross Hands primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692009||Ysgol Llangain
Y Partneriaeth||Carmarthenshire County Counil||669||6692014||Ysgol Gymunedol Peniel
Y Partneriaeth||Carmarthenshire County Counil||669||6692018||Ysgol Gymunedol Bancffosfelen
Y Partneriaeth||Carmarthenshire County Counil||669||6692019||Ysgol Gwynfryn
Y Partneriaeth||Carmarthenshire County Counil||669||6692020||Carway primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692023||Pontiets primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692024||Ysgol Ponthenri
Y Partneriaeth||Carmarthenshire County Counil||669||6692034||Ysgol Bancyfelin
Y Partneriaeth||Carmarthenshire County Counil||669||6692037||Ysgol Meidrim
Y Partneriaeth||Carmarthenshire County Counil||669||6692042||Ysgol Gynradd Saron
Y Partneriaeth||Carmarthenshire County Counil||669||6692043||Ysgol Gynradd Betws
Y Partneriaeth||Carmarthenshire County Counil||669||6692044||Ysgol Gynradd Ty-croes
Y Partneriaeth||Carmarthenshire County Counil||669||6692050||Ysgol Gynradd Parcyrhun
Y Partneriaeth||Carmarthenshire County Counil||669||6692052||Ysgol Gynradd Blaenau
Y Partneriaeth||Carmarthenshire County Counil||669||6692057||Ysgol Gynradd Llanedi
Y Partneriaeth||Carmarthenshire County Counil||669||6692061||Ysgol Gynradd Ffairfach
Y Partneriaeth||Carmarthenshire County Counil||669||6692065||Talley primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692067||Cwrt Henri primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692080||Llangadog primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692084||Ysgol Rhys Pritchard
Y Partneriaeth||Carmarthenshire County Counil||669||6692098||Ysgol Llys Hywel
Y Partneriaeth||Carmarthenshire County Counil||669||6692104||Ysgol Gynradd Brynsaron
Y Partneriaeth||Carmarthenshire County Counil||669||6692109||Llanpumsaint School
Y Partneriaeth||Carmarthenshire County Counil||669||6692112||Ysgol Mynyddygarreg
Y Partneriaeth||Carmarthenshire County Counil||669||6692114||Johnstown primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692116||Ysgol Y Dderwen
Y Partneriaeth||Carmarthenshire County Counil||669||6692119||Llanmiloe primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692120||Bryn primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692121||Ysgol Gynradd Bynea
Y Partneriaeth||Carmarthenshire County Counil||669||6692123||Dafen primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692128||Ysgol Gynradd Pum Heol
Y Partneriaeth||Carmarthenshire County Counil||669||6692131||Hendy primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692135||Furnace primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692159||Old Road  primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692166||Ysgol Llansteffan
Y Partneriaeth||Carmarthenshire County Counil||669||6692167||Ysgol Gynradd Llannon
Y Partneriaeth||Carmarthenshire County Counil||669||6692168||Ysgol Gymraeg Brynsierfel
Y Partneriaeth||Carmarthenshire County Counil||669||6692169||Brynamman primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692171||Myrddin primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692173||Llangunnor primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692175||Trimsaran primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692176||Swiss Valley primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692177||Parc Y Tywyn School
Y Partneriaeth||Carmarthenshire County Counil||669||6692178||Pembrey primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692179||Ysgol Gymraeg Rhydaman
Y Partneriaeth||Carmarthenshire County Counil||669||6692180||Ysgol Beca
Y Partneriaeth||Carmarthenshire County Counil||669||6692181||Llandybie primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692182||Ysgol Gynradd Hafodwenog
Y Partneriaeth||Carmarthenshire County Counil||669||6692183||Ysgol Teilo Sant
Y Partneriaeth||Carmarthenshire County Counil||669||6692184||Llanybydder primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692185||Llandeilo primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692187||Cynwyl Elfed School
Y Partneriaeth||Carmarthenshire County Counil||669||6692188||Halfway primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692189||Pwll primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692190||Penygaer primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692192||Ysgol Y Castell
Y Partneriaeth||Carmarthenshire County Counil||669||6692193||Penygroes primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692194||Ysgol Gynradd Gymunedol Nantgaredig
Y Partneriaeth||Carmarthenshire County Counil||669||6692370||Ysgol Gymraeg Gwenllian
Y Partneriaeth||Carmarthenshire County Counil||669||6692371||Ysgol Gymraeg Dewi Sant
Y Partneriaeth||Carmarthenshire County Counil||669||6692373||Pontyberem primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692374||Bigyn primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692375||Stebonheath primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692379||Ysgol Y Ddwylan
Y Partneriaeth||Carmarthenshire County Counil||669||6692380||Richmond Park School
Y Partneriaeth||Carmarthenshire County Counil||669||6692384||Ysgol Griffith Jones
Y Partneriaeth||Carmarthenshire County Counil||669||6692385||Ysgol y Fro
Y Partneriaeth||Carmarthenshire County Counil||669||6692386||Ysgol Carreg Hirfaen
Y Partneriaeth||Carmarthenshire County Counil||669||6692387||Cae'r Felin Community School
Y Partneriaeth||Carmarthenshire County Counil||669||6692388||Ysgol Y Bedol
Y Partneriaeth||Carmarthenshire County Counil||669||6692389||Ysgol Bro Brynach
Y Partneriaeth||Carmarthenshire County Counil||669||6692390||Ysgol Bryn Teg
Y Partneriaeth||Carmarthenshire County Counil||669||6692391||Ysgol Y Felin
Y Partneriaeth||Carmarthenshire County Counil||669||6692392||Ysgol Bro Banw
Y Partneriaeth||Carmarthenshire County Counil||669||6692393||Maes Y Morfa primaryCommunity School
Y Partneriaeth||Carmarthenshire County Counil||669||6692394||Burry Port Community primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6692395||Ysgol Pen Rhos
Y Partneriaeth||Carmarthenshire County Counil||669||6692396||Ysgol Gymraeg Llangennech
Y Partneriaeth||Carmarthenshire County Counil||669||6693000||Abergwili VC primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6693003||Laugharne VCP School
Y Partneriaeth||Carmarthenshire County Counil||669||6693004||Ysgol Llanddarog
Y Partneriaeth||Carmarthenshire County Counil||669||6693013||Ferryside VCP School
Y Partneriaeth||Carmarthenshire County Counil||669||6693026||Ysgol Llanllwni
Y Partneriaeth||Carmarthenshire County Counil||669||6693300||St Mary's Catholic primarySchool (Llanelli)
Y Partneriaeth||Carmarthenshire County Counil||669||6693301||St Mary's RC primarySchool (Carmarthen)
Y Partneriaeth||Carmarthenshire County Counil||669||6693307||Ysgol Penboyr
Y Partneriaeth||Carmarthenshire County Counil||669||6693321||Pentip VA CiW primarySchool
Y Partneriaeth||Carmarthenshire County Counil||669||6693322||Model CiW School
Y Partneriaeth||Carmarthenshire County Counil||669||6694029||Ysgol Dyffryn Aman
Y Partneriaeth||Carmarthenshire County Counil||669||6694050||Coedcae School
Y Partneriaeth||Carmarthenshire County Counil||669||6694052||Ysgol Gyfun Y Strade
Y Partneriaeth||Carmarthenshire County Counil||669||6694053||Glan-y-Mor School
Y Partneriaeth||Carmarthenshire County Counil||669||6694054||Bryngwyn School
Y Partneriaeth||Carmarthenshire County Counil||669||6694056||Ysgol Gyfun Gymraeg Bro Myrddin
Y Partneriaeth||Carmarthenshire County Counil||669||6694060||Ysgol Gyfun Emlyn
Y Partneriaeth||Carmarthenshire County Counil||669||6694063||Queen Elizabeth High School
Y Partneriaeth||Carmarthenshire County Counil||669||6694064||Ysgol Maes y Gwendraeth
Y Partneriaeth||Carmarthenshire County Counil||669||6694065||Ysgol Bro Dinefwr
Y Partneriaeth||Carmarthenshire County Counil||669||6694512||Dyffryn Taf
Y Partneriaeth||Carmarthenshire County Counil||669||6694600||St John Lloyd Catholic School
Y Partneriaeth||Carmarthenshire County Counil||669||6697000||Heol Goffa School
Y Partneriaeth||City and County of Swansea||670||6701113||Maes Derw
Y Partneriaeth||City and County of Swansea||670||6702006||Brynmill primarySchool
Y Partneriaeth||City and County of Swansea||670||6702008||Cadle primarySchool
Y Partneriaeth||City and County of Swansea||670||6702014||Cwmrhydyceirw primarySchool
Y Partneriaeth||City and County of Swansea||670||6702017||Danygraig primarySchool
Y Partneriaeth||City and County of Swansea||670||6702021||Gendros primarySchool
Y Partneriaeth||City and County of Swansea||670||6702023||Glais primarySchool
Y Partneriaeth||City and County of Swansea||670||6702027||Grange primarySchool
Y Partneriaeth||City and County of Swansea||670||6702032||Hafod primarySchool
Y Partneriaeth||City and County of Swansea||670||6702036||YGG Lon Las
Y Partneriaeth||City and County of Swansea||670||6702040||Morriston primarySchool
Y Partneriaeth||City and County of Swansea||670||6702042||Oystermouth primarySchool
Y Partneriaeth||City and County of Swansea||670||6702048||Pentrechwyth primarySchool
Y Partneriaeth||City and County of Swansea||670||6702051||Plasmarl primarySchool
Y Partneriaeth||City and County of Swansea||670||6702054||Sketty primarySchool
Y Partneriaeth||City and County of Swansea||670||6702055||St Helen's primarySchool
Y Partneriaeth||City and County of Swansea||670||6702059||Terrace Road primarySchool
Y Partneriaeth||City and County of Swansea||670||6702063||Townhill Community primarySchool
Y Partneriaeth||City and County of Swansea||670||6702065||Waunarlwydd primarySchool
Y Partneriaeth||City and County of Swansea||670||6702067||Waun Wen primarySchool
Y Partneriaeth||City and County of Swansea||670||6702069||Clwyd Community primarySchool
Y Partneriaeth||City and County of Swansea||670||6702071||Ynystawe primarySchool
Y Partneriaeth||City and County of Swansea||670||6702073||Clase primarySchool
Y Partneriaeth||City and County of Swansea||670||6702075||Portmead primarySchool
Y Partneriaeth||City and County of Swansea||670||6702076||Mayals primarySchool
Y Partneriaeth||City and County of Swansea||670||6702077||Cwmglas primarySchool
Y Partneriaeth||City and County of Swansea||670||6702082||Blaenymaes primarySchool
Y Partneriaeth||City and County of Swansea||670||6702084||Trallwn primarySchool
Y Partneriaeth||City and County of Swansea||670||6702086||Parkland primarySchool
Y Partneriaeth||City and County of Swansea||670||6702092||Newton primarySchool
Y Partneriaeth||City and County of Swansea||670||6702095||Whitestone primarySchool
Y Partneriaeth||City and County of Swansea||670||6702096||Hendrefoilan primarySchool
Y Partneriaeth||City and County of Swansea||670||6702098||YGG Brynymor
Y Partneriaeth||City and County of Swansea||670||6702105||Bishopston primarySchool
Y Partneriaeth||City and County of Swansea||670||6702108||Casllwchwr primarySchool
Y Partneriaeth||City and County of Swansea||670||6702109||Cila primarySchool
Y Partneriaeth||City and County of Swansea||670||6702120||Crwys primarySchool
Y Partneriaeth||City and County of Swansea||670||6702157||Llangyfelach primarySchool
Y Partneriaeth||City and County of Swansea||670||6702159||Llanrhidian primarySchool
Y Partneriaeth||City and County of Swansea||670||6702167||Penclawdd primarySchool
Y Partneriaeth||City and County of Swansea||670||6702172||Pengelli primarySchool
Y Partneriaeth||City and County of Swansea||670||6702174||Penllergaer primarySchool
Y Partneriaeth||City and County of Swansea||670||6702176||Penyrheol primarySchool
Y Partneriaeth||City and County of Swansea||670||6702186||Pontarddulais primarySchool
Y Partneriaeth||City and County of Swansea||670||6702189||YGG Bryniago
Y Partneriaeth||City and County of Swansea||670||6702192||Pontlliw primarySchool
Y Partneriaeth||City and County of Swansea||670||6702211||Tre Uchaf primarySchool
Y Partneriaeth||City and County of Swansea||670||6702212||YGG Pontybrenin
Y Partneriaeth||City and County of Swansea||670||6702215||Craigfelen primarySchool
Y Partneriaeth||City and County of Swansea||670||6702216||Pennard primarySchool
Y Partneriaeth||City and County of Swansea||670||6702217||Knelston primarySchool
Y Partneriaeth||City and County of Swansea||670||6702219||Pen-y-Fro Primary
Y Partneriaeth||City and County of Swansea||670||6702223||Pontybrenin primarySchool
Y Partneriaeth||City and County of Swansea||670||6702225||Talycopa primarySchool
Y Partneriaeth||City and County of Swansea||670||6702226||Glyncollen primarySchool
Y Partneriaeth||City and County of Swansea||670||6702229||YGG Y Login Fach
Y Partneriaeth||City and County of Swansea||670||6702231||YGG Tirdeunaw
Y Partneriaeth||City and County of Swansea||670||6702232||YGG Gellionnen
Y Partneriaeth||City and County of Swansea||670||6702233||Gors Community primarySchool
Y Partneriaeth||City and County of Swansea||670||6702234||Sea View Community primarySchool
Y Partneriaeth||City and County of Swansea||670||6702235||YGG Llwynderw
Y Partneriaeth||City and County of Swansea||670||6702236||Birchgrove primarySchool
Y Partneriaeth||City and County of Swansea||670||6702237||Dunvant primarySchool
Y Partneriaeth||City and County of Swansea||670||6702238||Gwyrosydd primarySchool
Y Partneriaeth||City and County of Swansea||670||6702239||St Thomas Community primarySchool
Y Partneriaeth||City and County of Swansea||670||6702240||Gowerton primarySchool
Y Partneriaeth||City and County of Swansea||670||6702241||Pentre'r Graig primarySchool
Y Partneriaeth||City and County of Swansea||670||6702242||YGG Tan-y-lan 
Y Partneriaeth||City and County of Swansea||670||6702243||Burlais primarySchool
Y Partneriaeth||City and County of Swansea||670||6702244||Clydach primarySchool
Y Partneriaeth||City and County of Swansea||670||6702245||Ysgol Gymraeg y Cwm
Y Partneriaeth||City and County of Swansea||670||6702246||Gorseinon primarySchool
Y Partneriaeth||City and County of Swansea||670||6702247||Brynhyfryd primarySchool
Y Partneriaeth||City and County of Swansea||670||6703303||St David's Catholic primarySchool
Y Partneriaeth||City and County of Swansea||670||6703305||St Illtyd's Catholic primarySchool
Y Partneriaeth||City and County of Swansea||670||6703306||Christchurch (CiW) Voluntary Aided School
Y Partneriaeth||City and County of Swansea||670||6703308||St Joseph's Catholic primarySchool (Clydach)
Y Partneriaeth||City and County of Swansea||670||6703309||St Joseph's Cathedral primarySchool
Y Partneriaeth||City and County of Swansea||670||6704031||Cefn Hengoed Community School
Y Partneriaeth||City and County of Swansea||670||6704032||Olchfa School
Y Partneriaeth||City and County of Swansea||670||6704033||Morriston Comprehensive School
Y Partneriaeth||City and County of Swansea||670||6704043||Pentrehafod School
Y Partneriaeth||City and County of Swansea||670||6704044||Bishop Gore School
Y Partneriaeth||City and County of Swansea||670||6704062||Penyrheol Comprehensive School
Y Partneriaeth||City and County of Swansea||670||6704063||Gowerton School
Y Partneriaeth||City and County of Swansea||670||6704069||Bishopston Comprehensive School
Y Partneriaeth||City and County of Swansea||670||6704072||Pontarddulais Comprehensive School
Y Partneriaeth||City and County of Swansea||670||6704074||Ysgol Gyfun Gwyr
Y Partneriaeth||City and County of Swansea||670||6704075||Birchgrove Comprehensive School
Y Partneriaeth||City and County of Swansea||670||6704076||Dylan Thomas Community School
Y Partneriaeth||City and County of Swansea||670||6704078||Ysgol Gyfun Bryn Tawe
Y Partneriaeth||City and County of Swansea||670||6704600||Bishop Vaughan School
Y Partneriaeth||City and County of Swansea||670||6707009||Ysgol Calon Lan
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712100||Alltwen primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712101||Blaendulais primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712106||Blaengwrach primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712110||Blaenhonddan primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712119||Baglan primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712128||YGGD Cwmllynfell
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712129||Creunant primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712134||Crymlyn primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712137||Cwmnedd primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712138||Cymer Afan primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712140||Godre'rgraig primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712142||Eastern primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712144||Gnoll primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712148||Glyncorrwg primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712149||YGG Gwaun Cae Gurwen
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712150||Catwg primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712155||Maesmarchog Community primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712158||YGG Rhosafan
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712161||Sandfields primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712168||YGG Castell-nedd
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712173||Croeserw primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712175||Tywyn primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712178||Llangiwg primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712181||Tonnau primaryCommunity School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712187||Ynysfach primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712191||Blaenbaglan primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712200||Rhos primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712202||YGG Blaendulais
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712203||Rhydyfro primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712205||YGG Cwm Nedd
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712206||Tairgwaith primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712208||YGGD Trebannws
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712218||YGG Pontardawe
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712221||Waunceirch primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712230||Cilffriw primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712231||YGG Tyle'r Ynn
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712232||Coed Hirwaun primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712233||Coedffranc primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712234||Pen Afan Primary
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712235||Awel Y Mor primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712236||Crynallt primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712237||Cwmafan primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712238||Central primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712239||Abbey primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712240||Melin primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712241||Ysgol Carreg Hir
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6712242||Ysgol Gynradd Gymraeg Tregeles
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6713309||St Joseph's Catholic primarySchool (Neath)
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6713310||St Joseph's Catholic Infant School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6713311||Bryncoch CiW primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6713313||Alderman Davies CiW primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6713314||St Therese's Catholic primarySchool
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6713316||St Joseph's Catholic Junior School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6714064||Cefn Saeson Comprehensive School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6714065||Cwmtawe Community School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6714066||Llangatwg Community School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6714067||Dwr Y Felin Comprehensive School
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6714601||St Joseph's RC School and 6th Form Centre
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6715500||Ysgol Bae Baglan
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6715501||Ysgol Gymraeg Ystalyfera Bro Dur
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6715502||Ysgol Cwm Brombil
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6717006||Ysgol Maes Y Coed
Neath Port Talbot||Neath Port Talbot County Borough Council||671||6717008||Ysgol Hendrefelin
CSC||Bridgend County Borough Council||672||6721102||Bridge Alternative Provision Portfolio PRU
CSC||Bridgend County Borough Council||672||6722046||Abercerdin primarySchool
CSC||Bridgend County Borough Council||672||6722051||Betws primarySchool
CSC||Bridgend County Borough Council||672||6722055||Blaengarw primarySchool
CSC||Bridgend County Borough Council||672||6722086||Brynmenyn primarySchool
CSC||Bridgend County Borough Council||672||6722090||Bryntirion Infants School
CSC||Bridgend County Borough Council||672||6722103||Cefn Cribwr primarySchool
CSC||Bridgend County Borough Council||672||6722109||Coety primarySchool
CSC||Bridgend County Borough Council||672||6722117||Cwmfelin primarySchool
CSC||Bridgend County Borough Council||672||6722122||Ffaldau primarySchool
CSC||Bridgend County Borough Council||672||6722129||Garth primarySchool
CSC||Bridgend County Borough Council||672||6722146||Coychurch (Llangrallo) primarySchool
CSC||Bridgend County Borough Council||672||6722149||Llangynwyd primarySchool
CSC||Bridgend County Borough Council||672||6722172||Nantyffyllon primarySchool
CSC||Bridgend County Borough Council||672||6722178||Nantymoel primarySchool
CSC||Bridgend County Borough Council||672||6722185||Newton primarySchool
CSC||Bridgend County Borough Council||672||6722194||Nottage primarySchool
CSC||Bridgend County Borough Council||672||6722220||Penybont primarySchool
CSC||Bridgend County Borough Council||672||6722227||Pil primarySchool
CSC||Bridgend County Borough Council||672||6722232||Plasnewydd primarySchool
CSC||Bridgend County Borough Council||672||6722256||Trelales primarySchool
CSC||Bridgend County Borough Council||672||6722259||Ysgol Cynwyd Sant
CSC||Bridgend County Borough Council||672||6722275||Tynyrheol primarySchool
CSC||Bridgend County Borough Council||672||6722279||Croesty primarySchool
CSC||Bridgend County Borough Council||672||6722288||Corneli primarySchool
CSC||Bridgend County Borough Council||672||6722292||Llangewydd Junior School
CSC||Bridgend County Borough Council||672||6722296||Porthcawl primarySchool
CSC||Bridgend County Borough Council||672||6722298||Ysgol Gymraeg Bro Ogwr
CSC||Bridgend County Borough Council||672||6722300||Cefn Glas Infant School
CSC||Bridgend County Borough Council||672||6722301||West Park primarySchool
CSC||Bridgend County Borough Council||672||6722304||Afon-y-Felin primarySchool
CSC||Bridgend County Borough Council||672||6722342||Tondu primarySchool
CSC||Bridgend County Borough Council||672||6722358||Ysgol Y Ferch O'r Sger
CSC||Bridgend County Borough Council||672||6722363||YGG Calon y Cymoedd
CSC||Bridgend County Borough Council||672||6722367||Maes yr Haul primarySchool
CSC||Bridgend County Borough Council||672||6722368||Bryncethin primarySchool
CSC||Bridgend County Borough Council||672||6722369||Ogmore Vale primarySchool
CSC||Bridgend County Borough Council||672||6722370||Pencoed primarySchool
CSC||Bridgend County Borough Council||672||6722371||Oldcastle primarySchool
CSC||Bridgend County Borough Council||672||6722372||Brackla primarySchool
CSC||Bridgend County Borough Council||672||6722373||Caerau primarySchool
CSC||Bridgend County Borough Council||672||6722374||Litchard primarySchool
CSC||Bridgend County Borough Council||672||6722375||Tremains primarySchool
CSC||Bridgend County Borough Council||672||6722376||Mynydd Cynffig primarySchool
CSC||Bridgend County Borough Council||672||6723013||Penyfai CiW Primary
CSC||Bridgend County Borough Council||672||6723311||St Mary's & St Patrick's Catholic primarySchool
CSC||Bridgend County Borough Council||672||6723315||St. Robert's Catholic primarySchool
CSC||Bridgend County Borough Council||672||6723322||St Mary's Catholic primarySchool
CSC||Bridgend County Borough Council||672||6723323||Archdeacon John Lewis CiW primarySchool
CSC||Bridgend County Borough Council||672||6724059||Cynffig Comprehensive School
CSC||Bridgend County Borough Council||672||6724068||Bryntirion Comprehensive School
CSC||Bridgend County Borough Council||672||6724071||Maesteg School
CSC||Bridgend County Borough Council||672||6724076||Pencoed Comprehensive School
CSC||Bridgend County Borough Council||672||6724078||Brynteg School
CSC||Bridgend County Borough Council||672||6724080||Porthcawl Comprehensive School
CSC||Bridgend County Borough Council||672||6724085||Ysgol Gyfun Gymraeg Llangynwyd
CSC||Bridgend County Borough Council||672||6724086||Coleg Cymunedol Y Dderwen
CSC||Bridgend County Borough Council||672||6724601||Archbishop Mcgrath Catholic High School
CSC||Bridgend County Borough Council||672||6727003||Heronsbridge Special School
CSC||Bridgend County Borough Council||672||6727012||Ysgol Bryn Castell
CSC||Vale of Glamorgan County Borough Council||673||6732109||Albert primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732111||Barry Island primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732114||Cogan primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732115||Colcot primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732117||Fairfield primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732118||Gladstone primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732120||High Street primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732122||Holton primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732124||Jenner Park primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732126||South Point primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732127||Llanfair primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732128||Llangan primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732131||Palmerston primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732133||Rhws primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732136||Sully primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732138||Victoria primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732144||St Athan primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732146||St Illtyd primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732148||Evenlode primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732149||Llandough primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732151||Y Bont Faen primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732152||Ysgol Pen-y-Garth
CSC||Vale of Glamorgan County Borough Council||673||6732156||Ysgol Sant Baruc
CSC||Vale of Glamorgan County Borough Council||673||6732163||Oak Field primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732165||Ysgol Iolo Morganwg
CSC||Vale of Glamorgan County Borough Council||673||6732178||Ysgol Sant Curig
CSC||Vale of Glamorgan County Borough Council||673||6732179||Ysgol Gymraeg Gwaun Y Nant
CSC||Vale of Glamorgan County Borough Council||673||6732181||Cadoxton primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732182||Romilly primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732184||Ysgol Gymraeg Dewi Sant 
CSC||Vale of Glamorgan County Borough Council||673||6732185||Dinas Powys primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6732186||Ysgol Y Ddraig
CSC||Vale of Glamorgan County Borough Council||673||6733037||St Nicholas CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733047||Peterston Super Ely CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733057||Gwenfo CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733320||St Brides Major CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733321||Wick & Marcross CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733363||Pendoylan CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733364||St Andrews Major CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733365||Llansannor CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733367||St David's CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733368||St Joseph's RC primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733372||All Saints CiW primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6733373||St Helen's Catholic primarySchool
CSC||Vale of Glamorgan County Borough Council||673||6734060||Llantwit Major School
CSC||Vale of Glamorgan County Borough Council||673||6734067||St Cyres School
CSC||Vale of Glamorgan County Borough Council||673||6734068||Whitmore High School
CSC||Vale of Glamorgan County Borough Council||673||6734069||Pencoedtre High School
CSC||Vale of Glamorgan County Borough Council||673||6734612||St Richard Gwyn RC High School
CSC||Vale of Glamorgan County Borough Council||673||6735400||Stanwell School
CSC||Vale of Glamorgan County Borough Council||673||6735500||Ysgol Gymraeg Bro Morgannwg
CSC||Vale of Glamorgan County Borough Council||673||6735501||Cowbridge School
CSC||Vale of Glamorgan County Borough Council||673||6737024||Ysgol Y Deri
CSC||Rhondda Cynon Taf County Borough Council||674||6741106||Ty Gwyn Education Centres
CSC||Rhondda Cynon Taf County Borough Council||674||6741108||Tai Educational Centre
CSC||Rhondda Cynon Taf County Borough Council||674||6742044||Penderyn primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742045||Oaklands primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742052||Alaw primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742053||Abernant primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742061||Brynnau primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742066||Coedpenmaen County primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742069||Bodringallt primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742070||Blaengwawr primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742072||Coedylan primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742077||Caegarw primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742079||Cwmlai primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742083||Dolau primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742084||Capcoch primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742093||Caradog primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742102||Ffynnon Taf primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742112||Darran Park primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742118||Llanilltud Faerdref Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742119||Gelli primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742124||Llantrisant Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742127||Hafod primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742130||Maes-Y-Coed primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742134||Cwmdar County primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742137||Parclewis primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742142||Llanharan primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742143||Llwynypia primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742144||Darrenlas primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742151||Llanhari primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742160||Pontyclun primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742161||Parc primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742170||Hirwaun primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742180||Llwydcoed Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742182||Trallwng Infants School
CSC||Rhondda Cynon Taf County Borough Council||674||6742192||Pengeulan primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742196||Pontrhondda primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742199||Trehopcyn primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742200||Pontygwaith primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742206||Trerobart primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742218||Perthcelyn Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742222||Ton Pentre Junior School
CSC||Rhondda Cynon Taf County Borough Council||674||6742225||Craig Yr Hesg primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742228||Llwyncrwn primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742229||Ton Pentre Infants School
CSC||Rhondda Cynon Taf County Borough Council||674||6742235||YGG Aberdar
CSC||Rhondda Cynon Taf County Borough Council||674||6742243||Trealaw primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742244||Glenboi primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742247||Cefn primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742251||Treorchy primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742258||Williamstown primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742263||Maesybryn primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742264||Tylorstown primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742269||Tref-y-Rhyg primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742272||YGG Tonyrefail
CSC||Rhondda Cynon Taf County Borough Council||674||6742276||Penygawsi primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742284||YGG Llwyncelyn
CSC||Rhondda Cynon Taf County Borough Council||674||6742287||YGG Ynyswen
CSC||Rhondda Cynon Taf County Borough Council||674||6742306||Tonysguboriau primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742351||YGGG Llantrisant
CSC||Rhondda Cynon Taf County Borough Council||674||6742356||YGG Bodringallt
CSC||Rhondda Cynon Taf County Borough Council||674||6742359||YGG Castellau
CSC||Rhondda Cynon Taf County Borough Council||674||6742361||YGG Llyn y Forwyn
CSC||Rhondda Cynon Taf County Borough Council||674||6742362||YGG Evan James
CSC||Rhondda Cynon Taf County Borough Council||674||6742364||YGG Abercynon
CSC||Rhondda Cynon Taf County Borough Council||674||6742365||YGG Bronllwyn
CSC||Rhondda Cynon Taf County Borough Council||674||6742367||Miskin primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742369||Penpych Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742370||Hendreforgan Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742371||Penyrenglyn Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742372||Penywaun primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742373||Penrhys primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742374||Gwaunmeisgyn primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742375||Gwauncelyn Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742376||Penrhiwceibr Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742378||Ynyshir primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742380||Cwmclydach Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742381||Aberdare Park Primary
CSC||Rhondda Cynon Taf County Borough Council||674||6742382||Maerdy Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742383||Cwmbach Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742384||Ynysboeth Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742385||Abercynon Community primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742386||Cymmer primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742387||Cwmaman primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6742388||Ysgol Gynradd Gymraeg Awel Taf
CSC||Rhondda Cynon Taf County Borough Council||674||6743309||Our Lady's RC primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6743312||St Michael's RC primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6743313||SS Gabriel & Raphael RC primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6743314||St Margaret's RC primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6743317||Aberdare Town CiW primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6743319||Cwmbach CiW primarySchool
CSC||Rhondda Cynon Taf County Borough Council||674||6744019||Bryncelynnog Comprehensive School
CSC||Rhondda Cynon Taf County Borough Council||674||6744053||Mountain Ash Comprehensive School
CSC||Rhondda Cynon Taf County Borough Council||674||6744081||Treorchy Comprehensive School
CSC||Rhondda Cynon Taf County Borough Council||674||6744083||Ferndale Community School
CSC||Rhondda Cynon Taf County Borough Council||674||6744096||Y Pant Comprehensive School
CSC||Rhondda Cynon Taf County Borough Council||674||6744097||Ysgol Gyfun Cwm Rhondda
CSC||Rhondda Cynon Taf County Borough Council||674||6744105||Ysgol Gyfun Rhydywaun
CSC||Rhondda Cynon Taf County Borough Council||674||6744106||Aberdare Community School
CSC||Rhondda Cynon Taf County Borough Council||674||6744602||Cardinal Newman RC Comprehensive
CSC||Rhondda Cynon Taf County Borough Council||674||6744604||St John Baptist CiW High School
CSC||Rhondda Cynon Taf County Borough Council||674||6745500||Ysgol Llanhari
CSC||Rhondda Cynon Taf County Borough Council||674||6745501||Porth Community School
CSC||Rhondda Cynon Taf County Borough Council||674||6745502||Ysgol Nantgwyn
CSC||Rhondda Cynon Taf County Borough Council||674||6745503||Tonyrefail Community School
CSC||Rhondda Cynon Taf County Borough Council||674||6745504||Ysgol Garth Olwg
CSC||Rhondda Cynon Taf County Borough Council||674||6745505||Ysgol Afon Wen
CSC||Rhondda Cynon Taf County Borough Council||674||6745506||Ysgol Bro Taf
CSC||Rhondda Cynon Taf County Borough Council||674||6747006||Maesgwyn Special School
CSC||Rhondda Cynon Taf County Borough Council||674||6747008||Park Lane Special School
CSC||Rhondda Cynon Taf County Borough Council||674||6747011||Ysgol Hen Felin
CSC||Rhondda Cynon Taf County Borough Council||674||6747015||Ysgol Ty Coch
CSC||Merthyr Tydfil County Borough Council||675||6751106||PRU Ty Dysgu
CSC||Merthyr Tydfil County Borough Council||675||6752000||Abercanaid Community School
CSC||Merthyr Tydfil County Borough Council||675||6752002||Cyfarthfa Park primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752006||Caedraw primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752010||Gellifaelog primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752015||Pantysgallog primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752020||Gwaunfarren primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752022||Heolgerrig Community School
CSC||Merthyr Tydfil County Borough Council||675||6752039||Ynysowen Community primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752042||YGG Santes Tudful
CSC||Merthyr Tydfil County Borough Council||675||6752054||Bedlinog Community primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752231||Trelewis primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752330||Ysgol y Graig primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752346||YGG Rhyd-Y-Grug
CSC||Merthyr Tydfil County Borough Council||675||6752351||Ysgol Gynradd Coed y Dderwen
CSC||Merthyr Tydfil County Borough Council||675||6752352||Twynyrodyn Community School
CSC||Merthyr Tydfil County Borough Council||675||6752353||Edwardsville primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752354||Troedyrhiw primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752355||Dowlais primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6752356||Goetre primarySchool
CSC||Merthyr Tydfil County Borough Council||675||6754011||Afon Taf High School
CSC||Merthyr Tydfil County Borough Council||675||6754012||Pen-y-dre High School
CSC||Merthyr Tydfil County Borough Council||675||6754013||Cyfarthfa High School
CSC||Merthyr Tydfil County Borough Council||675||6755900||The Blessed Carlo Acutis Catholic School
CSC||Merthyr Tydfil County Borough Council||675||6757013||Greenfield Special School
EAS||Caerphilly County Borough Council||676||6761104||Glanynant Learning Centre (PRU)
EAS||Caerphilly County Borough Council||676||6762058||Pengam primarySchool
EAS||Caerphilly County Borough Council||676||6762061||Fleur-de-Lys primarySchool
EAS||Caerphilly County Borough Council||676||6762071||Coed-Y-Brain primarySchool
EAS||Caerphilly County Borough Council||676||6762078||Markham primarySchool
EAS||Caerphilly County Borough Council||676||6762081||Cwmaber Junior School
EAS||Caerphilly County Borough Council||676||6762084||Libanus primarySchool
EAS||Caerphilly County Borough Council||676||6762086||Pontllanfraith primarySchool
EAS||Caerphilly County Borough Council||676||6762089||Deri primarySchool
EAS||Caerphilly County Borough Council||676||6762093||Crumlin High Level primarySchool
EAS||Caerphilly County Borough Council||676||6762095||Pentwynmawr primarySchool
EAS||Caerphilly County Borough Council||676||6762097||Derwendeg primarySchool
EAS||Caerphilly County Borough Council||676||6762098||Tynewydd primarySchool
EAS||Caerphilly County Borough Council||676||6762100||Cwmcarn primarySchool
EAS||Caerphilly County Borough Council||676||6762103||Waunfawr primarySchool
EAS||Caerphilly County Borough Council||676||6762105||Risca primarySchool
EAS||Caerphilly County Borough Council||676||6762108||Fochriw primarySchool
EAS||Caerphilly County Borough Council||676||6762121||Gilfach Fargoed primarySchool
EAS||Caerphilly County Borough Council||676||6762148||Hengoed primarySchool
EAS||Caerphilly County Borough Council||676||6762158||Llancaeach Junior School
EAS||Caerphilly County Borough Council||676||6762171||Llanfabon Infants School
EAS||Caerphilly County Borough Council||676||6762193||Rhydri primarySchool
EAS||Caerphilly County Borough Council||676||6762197||Nant Y Parc primarySchool
EAS||Caerphilly County Borough Council||676||6762207||Pantside primarySchool
EAS||Caerphilly County Borough Council||676||6762224||Tiryberth primarySchool
EAS||Caerphilly County Borough Council||676||6762227||Ty Isaf Infants School
EAS||Caerphilly County Borough Council||676||6762252||Cwm Ifor primarySchool
EAS||Caerphilly County Borough Council||676||6762256||Bryn primarySchool
EAS||Caerphilly County Borough Council||676||6762262||Ysgol Ifor Bach
EAS||Caerphilly County Borough Council||676||6762264||Abercarn primarySchool
EAS||Caerphilly County Borough Council||676||6762278||Greenhill primarySchool
EAS||Caerphilly County Borough Council||676||6762282||Ysgol Gymraeg Caerffili
EAS||Caerphilly County Borough Council||676||6762285||Ysgol Gymraeg Gilfach Fargoed
EAS||Caerphilly County Borough Council||676||6762296||Ynysddu primarySchool
EAS||Caerphilly County Borough Council||676||6762307||Upper Rhymney primarySchool
EAS||Caerphilly County Borough Council||676||6762309||Ysgol Y Lawnt
EAS||Caerphilly County Borough Council||676||6762310||Bryn Awel primarySchool
EAS||Caerphilly County Borough Council||676||6762313||Ysgol Gymraeg Trelyn
EAS||Caerphilly County Borough Council||676||6762316||Phillipstown primarySchool
EAS||Caerphilly County Borough Council||676||6762322||Maesycwmmer primarySchool
EAS||Caerphilly County Borough Council||676||6762323||Bedwas Junior School
EAS||Caerphilly County Borough Council||676||6762326||Machen primarySchool
EAS||Caerphilly County Borough Council||676||6762328||Graig-y-Rhacca primary& Nursery Community School
EAS||Caerphilly County Borough Council||676||6762335||Bedwas Infant School
EAS||Caerphilly County Borough Council||676||6762338||Hendredenny Park primarySchool
EAS||Caerphilly County Borough Council||676||6762347||Cwmaber Infant School
EAS||Caerphilly County Borough Council||676||6762368||Ysgol Gymraeg Bro Allta
EAS||Caerphilly County Borough Council||676||6762370||Cwmfelinfach primarySchool
EAS||Caerphilly County Borough Council||676||6762373||Ysgol Gymraeg Cwm Gwyddon
EAS||Caerphilly County Borough Council||676||6762374||YGG Y Castell
EAS||Caerphilly County Borough Council||676||6762376||Cwrt Rawlin primarySchool
EAS||Caerphilly County Borough Council||676||6762377||Cefn Fforest primarySchool
EAS||Caerphilly County Borough Council||676||6762378||Penllwyn primarySchool
EAS||Caerphilly County Borough Council||676||6762379||Blackwood primarySchool
EAS||Caerphilly County Borough Council||676||6762380||Glyn-Gaer primarySchool
EAS||Caerphilly County Borough Council||676||6762381||Park primarySchool
EAS||Caerphilly County Borough Council||676||6762382||Aberbargoed primarySchool
EAS||Caerphilly County Borough Council||676||6762383||Trinant primarySchool
EAS||Caerphilly County Borough Council||676||6762384||Ty Sign primarySchool
EAS||Caerphilly County Borough Council||676||6762385||Tyn-y-Wern Primary
EAS||Caerphilly County Borough Council||676||6762386||The Twyn School
EAS||Caerphilly County Borough Council||676||6762387||White Rose primarySchool
EAS||Caerphilly County Borough Council||676||6762388||Ysgol Bro Sannan
EAS||Caerphilly County Borough Council||676||6762389||Plasyfelin primarySchool
EAS||Caerphilly County Borough Council||676||6762390||St James primarySchool
EAS||Caerphilly County Borough Council||676||6762391||St Gwladys Bargoed School
EAS||Caerphilly County Borough Council||676||6762392||Rhiw Syr Dafydd Primary
EAS||Caerphilly County Borough Council||676||6762393||Ystrad Mynach Primary
EAS||Caerphilly County Borough Council||676||6762394||Ysgol Gynradd Gymraeg Cwm Derwen
EAS||Caerphilly County Borough Council||676||6762395||Ysgol Penalltau
EAS||Caerphilly County Borough Council||676||6762396||Hendre Primary 
EAS||Caerphilly County Borough Council||676||6763310||St Helen's Catholic primarySchool
EAS||Caerphilly County Borough Council||676||6764031||Newbridge School
EAS||Caerphilly County Borough Council||676||6764046||Blackwood Comprehensive School
EAS||Caerphilly County Borough Council||676||6764065||St Cenydd School
EAS||Caerphilly County Borough Council||676||6764068||Risca Community Comprehensive School
EAS||Caerphilly County Borough Council||676||6764070||St Martin's Comprehensive School
EAS||Caerphilly County Borough Council||676||6764073||Heolddu Comprehensive School
EAS||Caerphilly County Borough Council||676||6764075||The Lewis School
EAS||Caerphilly County Borough Council||676||6764093||Bedwas High School
EAS||Caerphilly County Borough Council||676||6764103||Ysgol Gyfun Cwm Rhymni
EAS||Caerphilly County Borough Council||676||6764104||Islwyn High School
EAS||Caerphilly County Borough Council||676||6765500||Idris Davies School
EAS||Caerphilly County Borough Council||676||6767011||Trinity Fields School & Resource Centre
EAS||Blaenau Gwent County Borough Council||677||6772067||Bryn Bach primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772070||Glanhowy primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772072||Deighton primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772074||Georgetown CP School
EAS||Blaenau Gwent County Borough Council||677||6772179||Sofrydd primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772253||Cwm primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772277||Beaufort Hill primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772278||Willowtown primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772306||Blaen-y-Cwm primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772307||Ysgol Gymraeg Bro Helyg
EAS||Blaenau Gwent County Borough Council||677||6772309||Glyncoed primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772310||Rhos-y-Fedwyn Primary
EAS||Blaenau Gwent County Borough Council||677||6772311||Ystruth Primary
EAS||Blaenau Gwent County Borough Council||677||6772312||St Illtyd's primarySchool
EAS||Blaenau Gwent County Borough Council||677||6772313||Coed-y-Garn primarySchool
EAS||Blaenau Gwent County Borough Council||677||6773308||St Mary's RC Primary
EAS||Blaenau Gwent County Borough Council||677||6773309||St Mary's CiW primarySchool (Brynmawr)
EAS||Blaenau Gwent County Borough Council||677||6773315||All Saints RC primarySchool
EAS||Blaenau Gwent County Borough Council||677||6773316||St Joseph's RC primarySchool
EAS||Blaenau Gwent County Borough Council||677||6774061||Tredegar Comprehensive School
EAS||Blaenau Gwent County Borough Council||677||6775401||Brynmawr Foundation School
EAS||Blaenau Gwent County Borough Council||677||6775500||Ebbw Fawr Learning Community
EAS||Blaenau Gwent County Borough Council||677||6775501||Abertillery Learning Community
EAS||Blaenau Gwent County Borough Council||677||6777011||Pen-y-cwm Special School
EAS||Blaenau Gwent County Borough Council||677||6777012||The River Centre 3-16 Learning Community
EAS||Torfaen County Borough Council||678||6782203||Llanyrafon primarySchool
EAS||Torfaen County Borough Council||678||6782204||Maendy primarySchool
EAS||Torfaen County Borough Council||678||6782205||Llantarnam Community primarySchool
EAS||Torfaen County Borough Council||678||6782211||Pontnewydd primarySchool
EAS||Torfaen County Borough Council||678||6782249||Greenmeadow primarySchool
EAS||Torfaen County Borough Council||678||6782298||Cwmffrwdoer primarySchool
EAS||Torfaen County Borough Council||678||6782308||George Street primarySchool
EAS||Torfaen County Borough Council||678||6782312||Ysgol Gymraeg Cwmbran
EAS||Torfaen County Borough Council||678||6782315||Garnteg primarySchool
EAS||Torfaen County Borough Council||678||6782318||Ysgol Bryn Onnen
EAS||Torfaen County Borough Council||678||6782319||Woodlands Community primarySchool
EAS||Torfaen County Borough Council||678||6782320||New Inn primarySchool
EAS||Torfaen County Borough Council||678||6782321||Griffithstown primarySchool
EAS||Torfaen County Borough Council||678||6782322||Penygarn primarySchool
EAS||Torfaen County Borough Council||678||6782323||Blenheim Road Community primarySchool
EAS||Torfaen County Borough Council||678||6782324||Coed Eva primarySchool
EAS||Torfaen County Borough Council||678||6782325||Croesyceiliog primarySchool
EAS||Torfaen County Borough Council||678||6782326||Nant Celyn primarySchool 
EAS||Torfaen County Borough Council||678||6782327||Ysgol Panteg
EAS||Torfaen County Borough Council||678||6783028||Blaenavon Heritage Voluntary Controlled primarySchool
EAS||Torfaen County Borough Council||678||6783321||Our Lady of the Angels primaryRC School
EAS||Torfaen County Borough Council||678||6783324||St David's Cwmbran RC primarySchool
EAS||Torfaen County Borough Council||678||6783330||Henllys CiW primarySchool
EAS||Torfaen County Borough Council||678||6783331||Padre Pio RC primarySchool
EAS||Torfaen County Borough Council||678||6783332||Ponthir CiW School
EAS||Torfaen County Borough Council||678||6784051||Croesyceiliog School
EAS||Torfaen County Borough Council||678||6784070||Abersychan School
EAS||Torfaen County Borough Council||678||6784072||West Monmouth School
EAS||Torfaen County Borough Council||678||6784076||Cwmbran High School
EAS||Torfaen County Borough Council||678||6784603||St Alban's RC High School
EAS||Torfaen County Borough Council||678||6785500||Ysgol Gymraeg Gwynllyw
EAS||Torfaen County Borough Council||678||6787012||Crownbridge Special School
EAS||Monmouthshire County Borough Council||679||6791100||Monmouthshire PRU
EAS||Monmouthshire County Borough Council||679||6792057||Gilwern CP School
EAS||Monmouthshire County Borough Council||679||6792134||Goytre Fawr primarySchool
EAS||Monmouthshire County Borough Council||679||6792163||Undy CP School
EAS||Monmouthshire County Borough Council||679||6792164||Rogiet CP School
EAS||Monmouthshire County Borough Council||679||6792228||Pembroke primarySchool
EAS||Monmouthshire County Borough Council||679||6792243||Llanfihangel Crucorney CP School
EAS||Monmouthshire County Borough Council||679||6792246||Thornwell primarySchool
EAS||Monmouthshire County Borough Council||679||6792261||Durand primarySchool
EAS||Monmouthshire County Borough Council||679||6792263||Llandogo CP School
EAS||Monmouthshire County Borough Council||679||6792299||Shirenewton primarySchool
EAS||Monmouthshire County Borough Council||679||6792301||Trellech CP School
EAS||Monmouthshire County Borough Council||679||6792303||The Dell primarySchool
EAS||Monmouthshire County Borough Council||679||6792304||Overmonnow CP School
EAS||Monmouthshire County Borough Council||679||6792305||Cross Ash CP School
EAS||Monmouthshire County Borough Council||679||6792317||Ysgol Gymraeg Y Fenni
EAS||Monmouthshire County Borough Council||679||6792318||Ysgol Gymraeg Y Ffin
EAS||Monmouthshire County Borough Council||679||6792319||Cantref primarySchool
EAS||Monmouthshire County Borough Council||679||6792321||Kymin View Primary
EAS||Monmouthshire County Borough Council||679||6792322||Castle Park primarySchool
EAS||Monmouthshire County Borough Council||679||6792323||Llanfoist Fawr primarySchool
EAS||Monmouthshire County Borough Council||679||6792324||Dewstow primarySchool
EAS||Monmouthshire County Borough Council||679||6792325||Ysgol Gymraeg Trefynwy
EAS||Monmouthshire County Borough Council||679||6793004||Llantilio Pertholey CiW primarySchool
EAS||Monmouthshire County Borough Council||679||6793022||Usk CiW primarySchool
EAS||Monmouthshire County Borough Council||679||6793031||Raglan CiW VC primarySchool
EAS||Monmouthshire County Borough Council||679||6793032||Osbaston CiW primarySchool
EAS||Monmouthshire County Borough Council||679||6793310||Magor CiW primarySchool
EAS||Monmouthshire County Borough Council||679||6793317||Our Lady & St Michael's School
EAS||Monmouthshire County Borough Council||679||6793326||St Mary's RC primarySchool
EAS||Monmouthshire County Borough Council||679||6793327||Archbishop Rowan Williams CiW School
EAS||Monmouthshire County Borough Council||679||6794060||Monmouth Comprehensive School
EAS||Monmouthshire County Borough Council||679||6794065||Chepstow School
EAS||Monmouthshire County Borough Council||679||6794066||Caldicot School
EAS||Monmouthshire County Borough Council||679||6795500||King Henry VIII 3-19 School
EAS||Newport City Council||680||6801019||Newport Nursery School
EAS||Newport City Council||680||6801103||Bridge Achievement Centre
EAS||Newport City Council||680||6802003||Clytha primarySchool
EAS||Newport City Council||680||6802004||Crindau primarySchool
EAS||Newport City Council||680||6802009||Eveswell primarySchool
EAS||Newport City Council||680||6802017||Maesglas primary& Nursery School
EAS||Newport City Council||680||6802019||Maindee primarySchool
EAS||Newport City Council||680||6802022||Malpas Court primarySchool
EAS||Newport City Council||680||6802027||St Woolos primarySchool
EAS||Newport City Council||680||6802030||Somerton primarySchool
EAS||Newport City Council||680||6802039||Glasllwch primarySchool
EAS||Newport City Council||680||6802043||Malpas Park primarySchool
EAS||Newport City Council||680||6802209||Langstone primarySchool
EAS||Newport City Council||680||6802224||Llanmartin primarySchool
EAS||Newport City Council||680||6802236||Marshfield primarySchool
EAS||Newport City Council||680||6802258||Mount Pleasant Primary
EAS||Newport City Council||680||6802276||Rogerstone primarySchool
EAS||Newport City Council||680||6802295||High Cross primarySchool
EAS||Newport City Council||680||6802300||Pentrepoeth primarySchool
EAS||Newport City Council||680||6802302||Pillgwenlly primarySchool
EAS||Newport City Council||680||6802314||Ysgol Gymraeg Casnewydd
EAS||Newport City Council||680||6802315||Alway primarySchool
EAS||Newport City Council||680||6802316||Ringland primarySchool
EAS||Newport City Council||680||6802317||Millbrook primarySchool
EAS||Newport City Council||680||6802318||Monnow primarySchool
EAS||Newport City Council||680||6802319||Glan Usk primarySchool
EAS||Newport City Council||680||6802320||Ysgol Gymraeg Ifor Hael
EAS||Newport City Council||680||6802321||Lliswerry primarySchool
EAS||Newport City Council||680||6802322||St Julians primarySchool
EAS||Newport City Council||680||6802323||Ysgol Gymraeg Bro Teyrnon
EAS||Newport City Council||680||6802324||Caerleon Lodge Hill primarySchool
EAS||Newport City Council||680||6802325||St Andrew's primarySchool
EAS||Newport City Council||680||6802326||Gaer primarySchool
EAS||Newport City Council||680||6802327||Tredegar Park Primary
EAS||Newport City Council||680||6802328||Jubilee Park primarySchool
EAS||Newport City Council||680||6802329||Milton primarySchool
EAS||Newport City Council||680||6802330||Glan Llyn primarySchool
EAS||Newport City Council||680||6802331||Ysgol Gymraeg Nant Gwenlli
EAS||Newport City Council||680||6803002||Malpas Church In Wales Primary
EAS||Newport City Council||680||6803300||St David's primarySchool
EAS||Newport City Council||680||6803301||St Joseph's RC primarySchool
EAS||Newport City Council||680||6803302||St Mary's RC primarySchool
EAS||Newport City Council||680||6803304||St Michael's RC primarySchool
EAS||Newport City Council||680||6803305||St Patrick's RC primarySchool
EAS||Newport City Council||680||6803306||St Gabriel's RC primarySchool
EAS||Newport City Council||680||6803313||Charles Williams CiW primarySchool
EAS||Newport City Council||680||6804003||St Julian's School
EAS||Newport City Council||680||6804020||The John Frost School
EAS||Newport City Council||680||6804021||Llanwern High School
EAS||Newport City Council||680||6804025||Newport High School
EAS||Newport City Council||680||6804026||Lliswerry High School
EAS||Newport City Council||680||6804030||Bassaleg School
EAS||Newport City Council||680||6804059||Caerleon Comprehensive School
EAS||Newport City Council||680||6804060||Ysgol Gyfun Gwent Is Coed
EAS||Newport City Council||680||6804602||St Joseph's RC High School
EAS||Newport City Council||680||6807002||Maes Ebbw School
EAS||Newport City Council||680||6807004||Ysgol Bryn Derw
CSC||Cardiff Council||681||6811003||Grangetown Nursery School
CSC||Cardiff Council||681||6811017||Tremorfa Nursery School
CSC||Cardiff Council||681||6811018||Ely and Caerau Children's Centre
CSC||Cardiff Council||681||6811107||Bryn y Deryn School and Student Support Unit
CSC||Cardiff Council||681||6812001||Millbank primarySchool
CSC||Cardiff Council||681||6812003||Adamsdown primarySchool
CSC||Cardiff Council||681||6812005||Albany primarySchool
CSC||Cardiff Council||681||6812009||Baden Powell primarySchool
CSC||Cardiff Council||681||6812011||Birchgrove primarySchool
CSC||Cardiff Council||681||6812015||Trelai primarySchool
CSC||Cardiff Council||681||6812017||Fairwater primarySchool
CSC||Cardiff Council||681||6812019||Gabalfa primarySchool
CSC||Cardiff Council||681||6812031||Kitchener primarySchool
CSC||Cardiff Council||681||6812033||Lansdowne primarySchool
CSC||Cardiff Council||681||6812037||Moorland primarySchool
CSC||Cardiff Council||681||6812039||Radnor primarySchool
CSC||Cardiff Council||681||6812041||Rhydypenau primarySchool
CSC||Cardiff Council||681||6812043||Roath Park primarySchool
CSC||Cardiff Council||681||6812045||Greenway primarySchool
CSC||Cardiff Council||681||6812050||Stacey primarySchool
CSC||Cardiff Council||681||6812052||Ton-yr-Ywen primarySchool
CSC||Cardiff Council||681||6812061||Peter Lea primarySchool
CSC||Cardiff Council||681||6812065||Bryn Hafod primarySchool
CSC||Cardiff Council||681||6812069||Pen-y-Bryn primarySchool
CSC||Cardiff Council||681||6812072||Coed Glas primarySchool
CSC||Cardiff Council||681||6812074||Lakeside primarySchool
CSC||Cardiff Council||681||6812075||Pentrebane primarySchool
CSC||Cardiff Council||681||6812084||Mount Stuart Primary
CSC||Cardiff Council||681||6812090||Llanishen Fach primarySchool
CSC||Cardiff Council||681||6812092||Rhiwbeina primarySchool
CSC||Cardiff Council||681||6812094||Llanedeyrn primarySchool
CSC||Cardiff Council||681||6812096||Springwood primarySchool
CSC||Cardiff Council||681||6812101||Ninian Park primarySchool
CSC||Cardiff Council||681||6812104||Coryton primarySchool
CSC||Cardiff Council||681||6812107||Bryn Celyn primarySchool
CSC||Cardiff Council||681||6812111||Ysgol Gynradd Gwaelod y Garth primarySchool
CSC||Cardiff Council||681||6812132||Radyr primarySchool
CSC||Cardiff Council||681||6812137||Tongwynlais primarySchool
CSC||Cardiff Council||681||6812147||Llysfaen primarySchool
CSC||Cardiff Council||681||6812153||Bryn Deri primarySchool
CSC||Cardiff Council||681||6812164||Oakfield primarySchool
CSC||Cardiff Council||681||6812166||Ysgol Gymraeg Melin Gruffydd
CSC||Cardiff Council||681||6812169||Ysgol Y Wern
CSC||Cardiff Council||681||6812170||Ysgol Gymraeg Coed-Y-Gof
CSC||Cardiff Council||681||6812171||Ysgol Bro Eirwg
CSC||Cardiff Council||681||6812173||Ysgol Gymraeg Treganna
CSC||Cardiff Council||681||6812174||Willowbrook primarySchool
CSC||Cardiff Council||681||6812175||Pentyrch primarySchool
CSC||Cardiff Council||681||6812176||Thornhill primarySchool
CSC||Cardiff Council||681||6812177||Ysgol Pencae
CSC||Cardiff Council||681||6812179||Meadowlane primarySchool
CSC||Cardiff Council||681||6812180||Ysgol Mynydd Bychan
CSC||Cardiff Council||681||6812305||Creigiau primarySchool
CSC||Cardiff Council||681||6812306||Ysgol Gymraeg Pwll Coch
CSC||Cardiff Council||681||6812308||Ysgol Y Berllan Deg
CSC||Cardiff Council||681||6812310||Glan-yr-Afon primarySchool
CSC||Cardiff Council||681||6812311||Grangetown primarySchool
CSC||Cardiff Council||681||6812312||Herbert Thompson Primary
CSC||Cardiff Council||681||6812313||Ysgol Glan Morfa
CSC||Cardiff Council||681||6812314||Ysgol Pen Y Pil
CSC||Cardiff Council||681||6812315||Ysgol Gymraeg Nant Caerau
CSC||Cardiff Council||681||6812317||Rumney primarySchool
CSC||Cardiff Council||681||6812318||Windsor Clive primarySchool
CSC||Cardiff Council||681||6812319||Severn primarySchool
CSC||Cardiff Council||681||6812320||Hawthorn primarySchool
CSC||Cardiff Council||681||6812321||Danescourt primarySchool
CSC||Cardiff Council||681||6812322||Hywel Dda primarySchool
CSC||Cardiff Council||681||6812323||Ysgol Gynradd Gymraeg Pen-Y-Groes
CSC||Cardiff Council||681||6812324||Trowbridge primarySchool
CSC||Cardiff Council||681||6812325||Ysgol Glan Ceubal
CSC||Cardiff Council||681||6812326||Marlborough primarySchool
CSC||Cardiff Council||681||6812327||Pencaerau primaryschool
CSC||Cardiff Council||681||6812328||Glyncoed primarySchool
CSC||Cardiff Council||681||6812329||Whitchurch primarySchool
CSC||Cardiff Council||681||6812330||Pontprennau primarySchool
CSC||Cardiff Council||681||6812331||Howardian primarySchool
CSC||Cardiff Council||681||6812332||Ysgol Hamadryad
CSC||Cardiff Council||681||6812333||Ysgol Groes Wen
CSC||Cardiff Council||681||6812334||Fairoak Primary School
CSC||Cardiff Council||681||6813000||St Mellons CiW primarySchool
CSC||Cardiff Council||681||6813321||St Alban's RC primarySchool
CSC||Cardiff Council||681||6813323||St Cuthbert's RC primarySchool
CSC||Cardiff Council||681||6813328||St Joseph's RC primarySchool
CSC||Cardiff Council||681||6813330||St Mary's RC primarySchool
CSC||Cardiff Council||681||6813332||St Patrick's RC primarySchool
CSC||Cardiff Council||681||6813334||St Peter's RC primarySchool
CSC||Cardiff Council||681||6813336||St Cadoc's Catholic primarySchool
CSC||Cardiff Council||681||6813341||St Monica's CiW primarySchool
CSC||Cardiff Council||681||6813343||St Paul's CiW primarySchool
CSC||Cardiff Council||681||6813344||Tredegarville CiW primarySchool
CSC||Cardiff Council||681||6813346||Llandaff City CiW primarySchool
CSC||Cardiff Council||681||6813351||Christ The King Catholic primarySchool
CSC||Cardiff Council||681||6813353||St John Lloyd RC primarySchool
CSC||Cardiff Council||681||6813354||Holy Family RC primarySchool
CSC||Cardiff Council||681||6813355||St Mary The Virgin CiW primarySchool
CSC||Cardiff Council||681||6813357||All Saints CiW primarySchool
CSC||Cardiff Council||681||6813366||St Fagans CiW primarySchool
CSC||Cardiff Council||681||6813370||St Bernadette's Catholic primarySchool
CSC||Cardiff Council||681||6813371||St David's CiW primarySchool
CSC||Cardiff Council||681||6813373||Bishop Childs CiW primarySchool
CSC||Cardiff Council||681||6813374||St Philip Evans RC primarySchool
CSC||Cardiff Council||681||6813375||St Francis RC primarySchool
CSC||Cardiff Council||681||6814039||Cardiff High School
CSC||Cardiff Council||681||6814041||Willows High School
CSC||Cardiff Council||681||6814042||Fitzalan High School
CSC||Cardiff Council||681||6814049||Cantonian High School
CSC||Cardiff Council||681||6814051||Llanishen High School
CSC||Cardiff Council||681||6814054||Cathays High School
CSC||Cardiff Council||681||6814070||Radyr Comprehensive School
CSC||Cardiff Council||681||6814071||Ysgol Gyfun Gymraeg Glantaf
CSC||Cardiff Council||681||6814072||Ysgol Gyfun Gymraeg Plasmawr
CSC||Cardiff Council||681||6814074||Ysgol Gyfun Gymraeg Bro Edern
CSC||Cardiff Council||681||6814075||Cardiff West Community High School
CSC||Cardiff Council||681||6814076||Eastern High School
CSC||Cardiff Council||681||6814600||St Illtyd's Catholic High School
CSC||Cardiff Council||681||6814607||Mary Immaculate High School
CSC||Cardiff Council||681||6814608||The Bishop Of Llandaff CiW High School
CSC||Cardiff Council||681||6814609||St Teilo's CiW High School
CSC||Cardiff Council||681||6814611||Corpus Christi Catholic High School
CSC||Cardiff Council||681||6815403||Whitchurch High School
CSC||Cardiff Council||681||6817001||Greenhill Special School
CSC||Cardiff Council||681||6817005||Ysgol Cynefin
CSC||Cardiff Council||681||6817006||Woodlands High School
CSC||Cardiff Council||681||6817008||Riverbank School
CSC||Cardiff Council||681||6817011||Ty Gwyn Special School
CSC||Cardiff Council||681||6817019||The Hollies School
CSC||Cardiff Council||681||6817021||Meadowbank Special School
CSC||Cardiff Council||681||6819000||Cardiff EOTAS
`;




const dataArray = hwbDataText.split('\n');





const getData = () => {

  const regionalPartnershipList: DecodeRegionalPartnership[] = [];

  const localAuthorityList: WsDecodeLocalAuthority[] = [];

  const schoolList: WsDecodeSchool[] = [];



  dataArray.forEach((dataString: string) => {

    const textLineSplit = dataString.split('||');

    if (textLineSplit.length === 5) {

      const regionalPartnershipName = cleanString(textLineSplit[0]);

      const regionalPartnershipId = replaceAll(regionalPartnershipName.toLowerCase(), ' ', '_');

      const localAuthorityName = cleanString(textLineSplit[1]);

      const localAuthorityCode = cleanString(textLineSplit[2]);

      const schoolCode = cleanString(textLineSplit[3]);

      const schoolName = cleanString(textLineSplit[4]);



      let regionalPartnership: DecodeRegionalPartnership | undefined = regionalPartnershipList.find((item) => item.id === regionalPartnershipId);

      if (!regionalPartnership) {

        regionalPartnership = { id: regionalPartnershipId, name: regionalPartnershipName };

        regionalPartnershipList.push(regionalPartnership);

      }



      if (regionalPartnership) {

        let localAuthority: WsDecodeLocalAuthority | undefined = localAuthorityList.find((item) => item.id === localAuthorityCode);

        if (!localAuthority) {

          localAuthority = { id: localAuthorityCode, name: localAuthorityName, schools: [] };

          localAuthorityList.push(localAuthority);

        }


        
        if (localAuthority) {

          const findSchool = schoolList.find((item) => item.id === schoolCode);

          if (!findSchool) {

            const school: WsDecodeSchool = { id: schoolCode, regionalPartnershipId: regionalPartnership.id, localAuthorityId: localAuthority.id, name: schoolName };

            schoolList.push(school);

            // localAuthority.schools.push(school);

          }
        }

      }

    }

  });



  // if (process.env.NODE_ENV === 'development') {

  //   console.log('// regional partnerships');

  //   regionalPartnershipList.forEach((item) => {
  //     console.log(item);
  //   });

  //   console.log('// local authorities');

  //   localAuthorityList.forEach((item) => {
  //     console.log(item);
  //   });

  //   console.log('// schools');

  //   schoolList.forEach((item) => {
  //     console.log(item);
  //   });
  // }



  return {

    regionalPartnershipList: regionalPartnershipList.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      } else {
        return 0;
      }
    }),

    localAuthorityList: localAuthorityList.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      } else {
        return 0;
      }
    }),

    schoolList: schoolList.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      } else if (a.name < b.name) {
        return -1;
      } else {
        return 0;
      }
    })
  };
};



const data = getData();




// const regionalPartnershipList: DecodeRegionalPartnership[] = [];

// const localAuthorityList: WsDecodeLocalAuthority[] = [];

// const schoolList: WsDecodeSchool[] = [];



const getRegionalPartnershipList = () => {
  return data.regionalPartnershipList;
};

const getLocalAuthorityList = (): WsDecodeLocalAuthority[] => {

  return [
    { id: '1', name: 'Finance', schools: [] },
    { id: '2', name: 'HR / People & Organization', schools: [] },
    { id: '3', name: 'Supply Chain / Manufacturing', schools: [] },
    { id: '4', name: 'Marketing & Sales', schools: [] },
    { id: '5', name: 'Procurement', schools: [] },
    { id: '6', name: 'Legal & Compliance', schools: [] },
    { id: '7', name: 'IT / Digital / Data & AI', schools: [] },
    { id: '8', name: 'R&D / Innovation', schools: [] },
    { id: '9', name: 'Sustainability & Corporate Affairs', schools: [] },
  ];

  // return data.localAuthorityList;

};

const getSchoolList = () => {
  return data.schoolList;
};






const devDecodeHwbDataStart = async (): Promise<any> => {

  getData();

  return null;
};



export {
  devDecodeHwbDataStart,
  getRegionalPartnershipList,
  getLocalAuthorityList,
  getSchoolList
};
